/**
 * SelfAbout collection PLP — filters, sort, load more, quick add/view, save, affinity.
 * Event delegation so AJAX re-renders do not stack listeners.
 */
(function () {
  /* Theme force-load + app block may both include this file — boot once */
  if (window.__SA_COLLECTION__) return;
  window.__SA_COLLECTION__ = 1;

  var DENSITY_KEY = "selfabout_plp_density";
  var booted = false;
  var reducedMotion =
    window.matchMedia &&
    window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* Prefer sa_type=bundle over legacy sa_type=kit in the address bar. */
  (function migrateBundleTypeParam() {
    try {
      var url = new URL(window.location.href);
      var types = url.searchParams.getAll("sa_type");
      if (types.indexOf("kit") === -1) return;
      url.searchParams.delete("sa_type");
      types.forEach(function (value) {
        url.searchParams.append("sa_type", value === "kit" ? "bundle" : value);
      });
      window.history.replaceState({}, "", url.pathname + url.search + url.hash);
    } catch (_e) { }
  })();

  function cartAddUrl() {
    return window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root + "cart/add.js"
      : "/cart/add.js";
  }

  function rootUrl() {
    return window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root
      : "/";
  }

  function getRoot(node) {
    if (node && node.closest) {
      var direct = node.closest("[data-selfabout-collection]");
      if (direct) return direct;
      var toolbar = node.closest("[data-selfabout-collection-toolbar]");
      if (toolbar) {
        var pinFor = toolbar.getAttribute("data-sa-pin-for");
        if (pinFor) {
          var byId = document.getElementById(pinFor);
          if (byId && byId.hasAttribute("data-selfabout-collection")) return byId;
        }
        return document.querySelector("[data-selfabout-collection]");
      }
      var portaled = node.closest("[data-sa-portaled-for], [data-selfabout-filters], [data-selfabout-qv]");
      if (portaled) {
        var pFor = portaled.getAttribute("data-sa-portaled-for");
        if (pFor) {
          var pById = document.getElementById(pFor);
          if (pById && pById.hasAttribute("data-selfabout-collection")) return pById;
        }
        return document.querySelector("[data-selfabout-collection]");
      }
    }
    return document.querySelector("[data-selfabout-collection]") || document.getElementById("selfabout-collection");
  }

  function readJson(key) {
    try {
      var raw = window.localStorage.getItem(key);
      if (!raw) return [];
      var parsed = JSON.parse(raw);
      return Array.isArray(parsed) ? parsed : [];
    } catch (_e) {
      return [];
    }
  }

  function writeJson(key, items) {
    try {
      var next = JSON.stringify(items);
      if (window.localStorage.getItem(key) === next) return false;
      window.localStorage.setItem(key, next);
      return true;
    } catch (_e) {
      /* private mode */
      return false;
    }
  }

  function addToCart(variantId, quantity) {
    if (window.SelfAboutCart && window.SelfAboutCart.addItems) {
      return window.SelfAboutCart.addItems([
        { id: variantId, quantity: quantity || 1 },
      ]);
    }
    return fetch(cartAddUrl(), {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: quantity || 1 }],
      }),
    }).then(function (response) {
      if (!response.ok) throw new Error("add failed");
      return response.json();
    });
  }

  function fetchCart() {
    return fetch(rootUrl() + "cart.js", {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    }).then(function (response) {
      if (!response.ok) throw new Error("cart failed");
      return response.json();
    });
  }

  function changeCartQuantity(variantId, quantity) {
    var updates = {};
    updates[String(variantId)] = Number(quantity);
    return fetch(rootUrl() + "cart/update.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify({ updates: updates }),
    }).then(function (response) {
      if (!response.ok) throw new Error("change failed");
      return response.json();
    });
  }

  function cartQtyByVariant(cart) {
    var map = {};
    (cart && cart.items ? cart.items : []).forEach(function (item) {
      if (!item) return;
      var id = String(item.variant_id || item.id);
      map[id] = (map[id] || 0) + Number(item.quantity || 0);
    });
    return map;
  }

  function setStatus(root, message) {
    var node = root.querySelector("[data-selfabout-collection-status]");
    if (!node) return;
    node.textContent = message || "";
  }

  function lockScroll(lock) {
    document.documentElement.style.overflow = lock ? "hidden" : "";
  }

  /** Sheet is portaled to <body> while open, so the form can live outside root. */
  function findFiltersForm(root) {
    if (!root) return null;
    var panel = findPlpOverlay(root, "[data-selfabout-filters]");
    var form = panel && panel.querySelector("[data-selfabout-filters-form]");
    return form || root.querySelector("[data-selfabout-filters-form]");
  }

  function saveKey(root) {
    return root.getAttribute("data-storage-key") || "selfabout_saved_products";
  }

  function applyDensity(root, value) {
    var grid = root.querySelector("[data-selfabout-collection-grid]");
    if (!grid) return;
    grid.setAttribute("data-density", value);
    try {
      window.localStorage.setItem(DENSITY_KEY, value);
    } catch (_e) { }
    queryToolbarAll(root, "[data-density]").forEach(function (btn) {
      var on = btn.getAttribute("data-density") === value;
      btn.classList.toggle("is-active", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
    });
  }

  function restoreDensity(root) {
    applyDensity(root, window.localStorage.getItem(DENSITY_KEY) || "4");
  }

  function applyPageSize(root, value) {
    var allowed = { "12": true, "24": true, "36": true, "48": true };
    if (!allowed[String(value)]) return;
    queryToolbarAll(root, "[data-selfabout-page-size]").forEach(function (input) {
      input.value = String(value);
    });
    queryToolbarAll(root, "[data-page-size]").forEach(function (btn) {
      var on = btn.getAttribute("data-page-size") === String(value);
      btn.classList.toggle("is-active", on);
      btn.setAttribute("aria-pressed", on ? "true" : "false");
    });
    root.setAttribute("data-per-page", String(value));
  }

  function buildFilterUrl(root, form, overrides) {
    overrides = overrides || {};
    var url = new URL(window.location.href);
    var params = new URLSearchParams();
    var sort = queryToolbar(root, "[data-selfabout-sort]");
    var pageSize = queryToolbar(root, "[data-selfabout-page-size]");
    var sortValue =
      overrides.sortBy != null && overrides.sortBy !== ""
        ? overrides.sortBy
        : sort && sort.value;
    var pageSizeValue =
      overrides.pageSize != null && overrides.pageSize !== ""
        ? overrides.pageSize
        : pageSize && pageSize.value;
    if (sortValue) params.set("sort_by", sortValue);
    if (pageSizeValue) params.set("page_size", pageSizeValue);

    if (form) {
      form.querySelectorAll("[data-selfabout-facet-input]").forEach(function (input) {
        if (input.disabled) return;
        if (input.type === "checkbox" || input.type === "radio") {
          if (input.checked && input.value !== "") {
            params.append(input.name, input.value);
          }
        } else if (input.value !== "") {
          if (input.name === "sa_min" || input.name === "sa_max") {
            var n = Number(input.value);
            if (!Number.isFinite(n)) return;
            if (n < 100) n = 100;
            if (n > 50000) n = 50000;
            params.set(input.name, String(Math.round(n)));
            return;
          }
          params.set(input.name, input.value);
        }
      });
    } else {
      url.searchParams.forEach(function (value, key) {
        if (key === "page" || key === "sort_by" || key === "page_size") return;
        params.append(key, value);
      });
      if (sortValue) params.set("sort_by", sortValue);
      if (pageSizeValue) params.set("page_size", pageSizeValue);
    }

    /* Bundles page mode must survive Apply — form has no Type checkboxes there */
    ensureBundlesTypeParam(params);

    var qs = params.toString();
    return qs ? url.pathname + "?" + qs : url.pathname;
  }

  function ensureBundlesTypeParam(params) {
    if (!params) return;
    if (!isBundlesNav() && !isBundlesPlp()) return;
    /* Shop + Single products selected: don't force bundles mode */
    if (!isBundlesNav() && params.getAll("sa_type").indexOf("product") !== -1) {
      return;
    }
    var types = params.getAll("sa_type");
    var hasBundle =
      types.indexOf("bundle") !== -1 || types.indexOf("kit") !== -1;
    if (!hasBundle) params.append("sa_type", "bundle");
  }

  function isKitCard(card) {
    if (!card) return false;
    if (card.getAttribute("data-sa-kit") === "1") return true;
    if (card.querySelector(".selfabout-collection__badge--kit")) return true;
    var cols = String(card.getAttribute("data-sa-collections") || "").toLowerCase();
    return cols.split(",").some(function (part) {
      part = part.trim();
      return part === "bundles" || part === "kits";
    });
  }

  /* Drop non-bundle cards from the live grid immediately (no async wait). */
  function pruneNonBundleCards(root) {
    if (!root || !isBundlesPlp()) return 0;
    var removed = 0;
    root.querySelectorAll("[data-selfabout-card]").forEach(function (card) {
      if (isKitCard(card)) {
        card.classList.remove("is-sa-filtered-out");
        card.removeAttribute("hidden");
        return;
      }
      removed += 1;
      if (card.parentNode) card.parentNode.removeChild(card);
    });
    return removed;
  }

  function hrefIsBundlesPlp(href) {
    try {
      var url = new URL(href, window.location.origin);
      var path = (url.pathname || "").replace(/\/$/, "") || "/";
      if (/\/collections\/(bundles|everyday-carry)(\/|$)/i.test(path)) return true;
      if (!/\/collections\/all(\/|$)/i.test(path)) return false;
      var types = url.searchParams.getAll("sa_type");
      var wantBundle =
        types.indexOf("bundle") !== -1 || types.indexOf("kit") !== -1;
      var wantProduct = types.indexOf("product") !== -1;
      return wantBundle && !wantProduct;
    } catch (_e) {
      return false;
    }
  }

  /* Soft Shop ↔ Bundles: keep navbar underline on a single active key */
  function syncSoftNavActive(key) {
    try {
      if (typeof window.__saSyncNavActive === "function") {
        window.__saSyncNavActive(key);
        return;
      }
    } catch (_api) {}
    try {
      if (key) document.documentElement.setAttribute("data-sa-nav", key);
      ["sa-fixed-nav", "sa-fixed-drawer"].forEach(function (id) {
        var root = document.getElementById(id);
        if (!root) return;
        var links = root.querySelectorAll(":scope > li > a[data-sa-nav-key]");
        for (var i = 0; i < links.length; i++) {
          var on = links[i].getAttribute("data-sa-nav-key") === key;
          links[i].classList.toggle("selfabout-nav-active", on);
          if (on) {
            links[i].setAttribute("aria-current", "page");
          } else {
            links[i].removeAttribute("aria-current");
            links[i].removeAttribute("data-sa-active");
          }
        }
      });
    } catch (_fb) {}
  }

  function isSaleCard(card) {
    if (!card) return false;
    if (card.hasAttribute("data-sa-off")) return true;
    return Boolean(card.querySelector(".selfabout-collection__price-compare"));
  }

  function currentCollectionHandle() {
    var match = (window.location.pathname || "").match(/\/collections\/([^/?#]+)/i);
    return match && match[1] ? String(match[1]).toLowerCase() : "";
  }

  function collectionTypeMode() {
    var handle = currentCollectionHandle();
    if (handle === "bundles" || handle === "kits" || handle === "everyday-carry") {
      return "kits_only";
    }
    if (
      handle === "shop" ||
      handle === "all" ||
      handle === "all-accessories" ||
      handle === ""
    ) {
      return "mixed";
    }
    return "products_only";
  }

  function isBundlesPlp() {
    var path = (location.pathname || "").replace(/\/$/, "") || "/";
    var params = new URLSearchParams(location.search || "");
    var types = params.getAll("sa_type");
    if (/\/collections\/(bundles|everyday-carry)(\/|$)/i.test(path)) return true;
    if (!/\/collections\/all(\/|$)/i.test(path)) return false;
    var wantBundle =
      types.indexOf("bundle") !== -1 || types.indexOf("kit") !== -1;
    var wantProduct = types.indexOf("product") !== -1;
    /* Bundles nav = sa_type=bundle without also selecting single products */
    return wantBundle && !wantProduct;
  }

  function hasClientFilters(params) {
    params = params || new URLSearchParams(location.search || "");
    if (params.get("sa_rating")) return true;
    if (params.getAll("sa_deal").length) return true;
    if (params.getAll("sa_type").length) return true;
    if (params.getAll("sa_stock").length) return true;
    if (params.get("sa_min") || params.get("sa_max")) return true;
    return false;
  }

  function shopNameSuffix() {
    var title = document.title || "";
    var parts = title.split(/\s+[–—|-]\s+/);
    if (parts.length > 1) return parts[parts.length - 1].trim() || "SelfAbout";
    return "SelfAbout";
  }

  function mergeClientParamsIntoHref(href) {
    var target;
    try {
      target = new URL(href, window.location.origin);
    } catch (_e) {
      return href;
    }
    var current = new URLSearchParams(window.location.search || "");
    var keep = ["sa_type", "sa_rating", "sa_deal", "sa_stock", "sa_min", "sa_max", "page_size", "sort_by"];
    keep.forEach(function (key) {
      if (key === "sa_type" || key === "sa_deal" || key === "sa_stock") {
        if (!current.getAll(key).length) return;
        target.searchParams.delete(key);
        current.getAll(key).forEach(function (value) {
          target.searchParams.append(key, value);
        });
        return;
      }
      var value = current.get(key);
      if (value != null && value !== "" && !target.searchParams.has(key)) {
        target.searchParams.set(key, value);
      }
    });
    var qs = target.searchParams.toString();
    return qs ? target.pathname + "?" + qs : target.pathname;
  }

  function mergePaginationHref(href) {
    var target;
    try {
      target = new URL(href, window.location.origin);
    } catch (_e) {
      return mergeClientParamsIntoHref(href);
    }
    var current = new URL(window.location.href);
    var page = target.searchParams.get("page");
    var merged = new URL(current.pathname, window.location.origin);
    current.searchParams.forEach(function (value, key) {
      if (key === "page") return;
      merged.searchParams.append(key, value);
    });
    if (page && String(page) !== "1") {
      merged.searchParams.set("page", String(page));
    } else {
      merged.searchParams.delete("page");
    }
    var qs = merged.searchParams.toString();
    return qs ? merged.pathname + "?" + qs : merged.pathname;
  }

  function isPaginationFilterLink(link) {
    if (!link) return false;
    if (link.closest("[data-selfabout-pagination]")) return true;
    var rel = (link.getAttribute("rel") || "").toLowerCase();
    if (rel === "prev" || rel === "next") return true;
    return link.classList.contains("selfabout-collection__page-btn");
  }

  function preserveClientParamsOnLinks(root) {
    if (!root) return;
    root.querySelectorAll("[data-selfabout-filter-link]").forEach(function (link) {
      var href = link.getAttribute("href");
      if (!href || href.charAt(0) === "#") return;
      var label = (link.textContent || "").replace(/\s+/g, " ").trim().toLowerCase();
      var isClear =
        link.classList.contains("selfabout-collection__clear") ||
        label === "clear all";
      if (isClear) {
        if (!isBundlesPlp()) return;
        try {
          var clearUrl = new URL(href, window.location.origin);
          clearUrl.searchParams.delete("sa_type");
          clearUrl.searchParams.append("sa_type", "bundle");
          var sort = new URLSearchParams(window.location.search).get("sort_by");
          var pageSize = new URLSearchParams(window.location.search).get(
            "page_size",
          );
          if (sort) clearUrl.searchParams.set("sort_by", sort);
          if (pageSize) clearUrl.searchParams.set("page_size", pageSize);
          var cqs = clearUrl.searchParams.toString();
          link.setAttribute(
            "href",
            cqs ? clearUrl.pathname + "?" + cqs : clearUrl.pathname,
          );
        } catch (_e) { }
        return;
      }
      /* Never re-merge params onto chip remove hrefs — that undoes the remove */
      if (isClientChipRemoveLink(link)) return;
      if (isPaginationFilterLink(link)) {
        link.setAttribute("href", mergePaginationHref(href));
        return;
      }
      if (hasClientFilters()) {
        link.setAttribute("href", mergeClientParamsIntoHref(href));
      }
    });
  }

  function destroyOrphanToolbars(root) {
    unpinToolbar(root);
    var id = toolbarPinId(root);
    document
      .querySelectorAll(
        'body > [data-selfabout-collection-toolbar][data-sa-pin-for="' + id + '"]',
      )
      .forEach(function (el) {
        try {
          el.parentNode.removeChild(el);
        } catch (_e) { }
      });
  }

  function sanitizeClientFacetParams() {
    var mode = collectionTypeMode();
    if (mode === "mixed") return;
    var url = new URL(window.location.href);
    var types = url.searchParams.getAll("sa_type");
    var allowed = mode === "kits_only" ? "bundle" : "product";
    var filtered = types.filter(function (value) {
      return value === allowed || (allowed === "bundle" && value === "kit");
    }).map(function (value) {
      return value === "kit" ? "bundle" : value;
    });
    if (
      types.length === filtered.length &&
      types.every(function (value, index) {
        return value === filtered[index];
      })
    ) {
      return;
    }
    url.searchParams.delete("sa_type");
    filtered.forEach(function (value) {
      url.searchParams.append("sa_type", value);
    });
    try {
      window.history.replaceState({}, "", url.pathname + url.search);
    } catch (_e) { }
  }

  function typeFacetHtml(type) {
    return (
      '<fieldset class="selfabout-collection__facet" data-sa-client-facet="type">' +
      "<legend>Type</legend>" +
      '<ul class="selfabout-collection__facet-list">' +
      '<li><label class="selfabout-collection__facet-option"><input type="checkbox" name="sa_type" value="bundle" data-selfabout-facet-input' +
      (type.indexOf("bundle") !== -1 || type.indexOf("kit") !== -1
        ? " checked"
        : "") +
      "><span>Bundles</span></label></li>" +
      '<li><label class="selfabout-collection__facet-option"><input type="checkbox" name="sa_type" value="product" data-selfabout-facet-input' +
      (type.indexOf("product") !== -1 ? " checked" : "") +
      "><span>Single products</span></label></li>" +
      "</ul></fieldset>"
    );
  }

  function isBundlesNav() {
    return document.documentElement.getAttribute("data-sa-nav") === "bundles";
  }

  function ensureBundlesTypeHidden(form) {
    if (!form || !isBundlesNav()) return;
    var existing = form.querySelectorAll(
      'input[name="sa_type"][data-selfabout-facet-input]',
    );
    var hidden = null;
    existing.forEach(function (el) {
      if (el.type === "hidden") hidden = el;
      else if (el.parentNode) el.parentNode.removeChild(el);
    });
    if (!hidden) {
      hidden = document.createElement("input");
      hidden.type = "hidden";
      hidden.name = "sa_type";
      hidden.setAttribute("data-selfabout-facet-input", "");
      form.appendChild(hidden);
    }
    hidden.value = "bundle";
    hidden.disabled = false;
  }

  function repairClientFacets(form) {
    if (!form || collectionTypeMode() !== "mixed") return;
    var mount = form.querySelector("[data-sa-client-facets-mount]");
    if (!mount) return;
    var typeFacet = mount.querySelector('[data-sa-client-facet="type"]');
    /* Dedicated Bundles nav: page mode is already bundles — hide Type UI, keep hidden sa_type */
    if (isBundlesNav()) {
      if (typeFacet && typeFacet.parentNode) typeFacet.parentNode.removeChild(typeFacet);
      ensureBundlesTypeHidden(form);
      return;
    }
    var hidden = form.querySelectorAll(
      'input[type="hidden"][name="sa_type"][data-selfabout-facet-input]',
    );
    hidden.forEach(function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });
    /* Shop (and mixed catalogs): always keep Type so reopen keeps Bundles / Single products */
    if (!typeFacet) {
      var params = new URLSearchParams(window.location.search);
      var type = params.getAll("sa_type");
      var wrap = document.createElement("div");
      wrap.innerHTML = typeFacetHtml(type);
      var node = wrap.firstChild;
      if (node) mount.insertBefore(node, mount.firstChild);
    }
  }

  function hideDuplicateNativeFacets(form) {
    if (!form) return;
    /* Client mount owns Availability + Price — hide Shopify storefront duplicates */
    form.querySelectorAll("fieldset.selfabout-collection__facet").forEach(function (fs) {
      if (fs.getAttribute("data-sa-client-facet")) return;
      if (fs.classList.contains("selfabout-collection__facet--page-size")) return;
      var legend = fs.querySelector("legend");
      var text = ((legend && legend.textContent) || "").replace(/\s+/g, " ").trim().toLowerCase();
      if (!text) return;
      if (
        text === "availability" ||
        text.indexOf("availability") === 0 ||
        text === "price" ||
        text.indexOf("price") === 0
      ) {
        fs.hidden = true;
        fs.setAttribute("data-sa-native-facet-hidden", "1");
        fs.style.display = "none";
      }
    });
  }

  function ensureClientFacets(root) {
    var form = findFiltersForm(root);
    if (!form) return;
    var FACETS_VER = "v5";
    var ver = form.getAttribute("data-sa-client-facets") || "";
    if (ver === FACETS_VER) {
      repairClientFacets(form);
      hideDuplicateNativeFacets(form);
      return;
    }
    /* Rebuild mount when facet UI version changes (stock / price bounds) */
    var stale = form.querySelector("[data-sa-client-facets-mount]");
    if (stale && stale.parentNode) stale.parentNode.removeChild(stale);
    form.setAttribute("data-sa-client-facets", FACETS_VER);

    var panel = form.closest("[data-selfabout-filters]") || root;
    var head = panel.querySelector(".selfabout-collection__filters-head");
    if (head && !head.querySelector(".selfabout-collection__filters-lead")) {
      var titleWrap = document.createElement("div");
      var h2 = head.querySelector("h2");
      if (h2) {
        titleWrap.appendChild(h2);
        var lead = document.createElement("p");
        lead.className = "selfabout-collection__filters-lead";
        lead.textContent = "Refine by type, availability, price, rating, and more.";
        titleWrap.appendChild(lead);
        head.insertBefore(titleWrap, head.firstChild);
      }
    }

    var actions = form.querySelector(".selfabout-collection__filters-actions");
    var pageSizeFacet = form.querySelector(".selfabout-collection__facet--page-size");
    var params = new URLSearchParams(window.location.search);
    var deal = params.getAll("sa_deal");
    var type = params.getAll("sa_type");
    var stock = params.getAll("sa_stock");
    var typeMode = collectionTypeMode();

    form.querySelectorAll(".selfabout-collection__filters-empty").forEach(function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });

    var extra = document.createElement("div");
    extra.setAttribute("data-sa-client-facets-mount", "");
    var blocks = "";
    /* Shop: Type first so customers pick product kind before price */
    if (typeMode === "mixed" && !isBundlesNav()) {
      blocks += typeFacetHtml(type);
    }
    blocks +=
      '<fieldset class="selfabout-collection__facet" data-sa-client-facet="availability">' +
      "<legend>Availability</legend>" +
      '<ul class="selfabout-collection__facet-list">' +
      '<li><label class="selfabout-collection__facet-option"><input type="checkbox" name="sa_stock" value="in" data-selfabout-facet-input' +
      (stock.indexOf("in") !== -1 ? " checked" : "") +
      "><span>In stock</span><em></em></label></li>" +
      '<li><label class="selfabout-collection__facet-option"><input type="checkbox" name="sa_stock" value="out" data-selfabout-facet-input' +
      (stock.indexOf("out") !== -1 ? " checked" : "") +
      "><span>Out of stock</span><em></em></label></li>" +
      "</ul></fieldset>" +
      '<fieldset class="selfabout-collection__facet" data-sa-client-facet="price">' +
      "<legend>Price</legend>" +
      '<div class="selfabout-collection__price">' +
      '<label class="selfabout-collection__price-field"><span class="selfabout-collection__price-label">From</span>' +
      '<input type="number" name="sa_min" min="100" max="50000" step="1" placeholder="100" inputmode="numeric" data-selfabout-facet-input value="' +
      (params.get("sa_min") || "").replace(/"/g, "") +
      '"></label>' +
      '<label class="selfabout-collection__price-field"><span class="selfabout-collection__price-label">To</span>' +
      '<input type="number" name="sa_max" min="100" max="50000" step="1" placeholder="50000" inputmode="numeric" data-selfabout-facet-input value="' +
      (params.get("sa_max") || "").replace(/"/g, "") +
      '"></label>' +
      "</div></fieldset>" +
      /* Rating facet retired — Judge.me owns star badges; sa_rating filter removed */
      '<fieldset class="selfabout-collection__facet" data-sa-client-facet="deal">' +
      "<legend>Deals</legend>" +
      '<ul class="selfabout-collection__facet-list">' +
      '<li><label class="selfabout-collection__facet-option"><input type="checkbox" name="sa_deal" value="sale" data-selfabout-facet-input' +
      (deal.indexOf("sale") !== -1 ? " checked" : "") +
      "><span>On sale</span></label></li>" +
      "</ul></fieldset>";
    extra.innerHTML = blocks;

    /* Keep Per page last (above Apply) — insert client facets before it */
    var mountBefore = pageSizeFacet || actions;
    if (mountBefore) form.insertBefore(extra, mountBefore);
    else form.appendChild(extra);
    ensureBundlesTypeHidden(form);
    hideDuplicateNativeFacets(form);
  }

  function syncClientFacetInputs(root) {
    var form = findFiltersForm(root);
    if (!form) return;
    var params = new URLSearchParams(window.location.search);
    var rating = params.get("sa_rating") || "";
    form.querySelectorAll('input[name="sa_rating"]').forEach(function (input) {
      input.checked = input.value === rating;
    });
    var deals = params.getAll("sa_deal");
    form.querySelectorAll('input[name="sa_deal"]').forEach(function (input) {
      input.checked = deals.indexOf(input.value) !== -1;
    });
    var types = params.getAll("sa_type");
    form.querySelectorAll('input[name="sa_type"]').forEach(function (input) {
      if (input.type === "hidden") {
        input.checked = true;
        return;
      }
      var checked =
        types.indexOf(input.value) !== -1 ||
        (input.value === "bundle" && types.indexOf("kit") !== -1);
      input.checked = checked;
    });
    var stocks = params.getAll("sa_stock");
    form.querySelectorAll('input[name="sa_stock"]').forEach(function (input) {
      input.checked = stocks.indexOf(input.value) !== -1;
    });
    var minEl = form.querySelector('input[name="sa_min"]');
    var maxEl = form.querySelector('input[name="sa_max"]');
    if (minEl) minEl.value = params.get("sa_min") || "";
    if (maxEl) maxEl.value = params.get("sa_max") || "";
  }

  function hrefWithoutClientParam(key, value) {
    var url = new URL(window.location.href);
    if (key === "sa_price") {
      url.searchParams.delete("sa_min");
      url.searchParams.delete("sa_max");
    } else if (key === "sa_type" || key === "sa_deal" || key === "sa_stock") {
      var kept = url.searchParams.getAll(key).filter(function (v) {
        return v !== value && !(key === "sa_type" && value === "bundle" && v === "kit");
      });
      url.searchParams.delete(key);
      kept.forEach(function (v) {
        url.searchParams.append(key, v);
      });
    } else {
      url.searchParams.delete(key);
    }
    url.searchParams.delete("page");
    var qs = url.searchParams.toString();
    return qs ? url.pathname + "?" + qs : url.pathname;
  }

  function isClientChipRemoveLink(link) {
    return Boolean(
      link &&
      (link.hasAttribute("data-sa-client-chip-remove") ||
        link.closest("[data-sa-client-chip]")),
    );
  }

  var CHIP_REMOVE_ICON =
    '<svg viewBox="0 0 12 12" width="11" height="11" aria-hidden="true" focusable="false"><path d="M3 3l6 6M9 3L3 9" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

  function polishChipRemoveIcons(root) {
    var wrap = root && root.querySelector("[data-selfabout-active-chips]");
    if (!wrap) return;
    wrap.querySelectorAll(".selfabout-collection__active-chip-remove").forEach(
      function (remove) {
        if (remove.querySelector("svg")) return;
        remove.innerHTML = CHIP_REMOVE_ICON;
      },
    );
  }

  function normalizeActiveChips(root) {
    var wrap = root && root.querySelector("[data-selfabout-active-chips]");
    if (!wrap) return;
    wrap.querySelectorAll("a.selfabout-collection__active-chip").forEach(
      function (a) {
        var href = a.getAttribute("href") || "";
        var labelEl = a.querySelector("span:not([aria-hidden])");
        var label = labelEl
          ? (labelEl.textContent || "").trim()
          : (a.textContent || "").replace(/\u00d7/g, "").trim();
        var span = document.createElement("span");
        span.className = "selfabout-collection__active-chip";
        var text = document.createElement("span");
        text.textContent = label;
        var remove = document.createElement("a");
        remove.className = "selfabout-collection__active-chip-remove";
        remove.setAttribute("href", href);
        remove.setAttribute("data-selfabout-filter-link", "");
        remove.setAttribute("aria-label", "Remove " + label);
        remove.innerHTML = CHIP_REMOVE_ICON;
        span.appendChild(text);
        span.appendChild(remove);
        if (a.parentNode) a.parentNode.replaceChild(span, a);
      },
    );
    polishChipRemoveIcons(root);
  }

  function renderClientActiveChips(root) {
    var wrap = root.querySelector("[data-selfabout-active-chips]");
    if (!wrap) return;
    wrap.querySelectorAll("[data-sa-client-chip]").forEach(function (el) {
      if (el.parentNode) el.parentNode.removeChild(el);
    });

    var params = new URLSearchParams(window.location.search || "");
    var chips = [];
    if (params.getAll("sa_deal").indexOf("sale") !== -1) {
      chips.push({
        key: "sa_deal",
        value: "sale",
        label: "On sale",
      });
    }
    var stocks = params.getAll("sa_stock");
    if (stocks.indexOf("in") !== -1) {
      chips.push({ key: "sa_stock", value: "in", label: "In stock" });
    }
    if (stocks.indexOf("out") !== -1) {
      chips.push({ key: "sa_stock", value: "out", label: "Out of stock" });
    }
    var rating = params.get("sa_rating");
    if (rating === "4") chips.push({ key: "sa_rating", value: "4", label: "4★ & up" });
    if (rating === "3") chips.push({ key: "sa_rating", value: "3", label: "3★ & up" });
    if (rating === "1") {
      chips.push({
        key: "sa_rating",
        value: "1",
        label: isBundlesPlp() ? "Rated bundles" : "Rated products",
      });
    }
    var types = params.getAll("sa_type");
    /* On dedicated Bundles nav, sa_type=bundle is the page mode — don't chip it */
    var navBundles = isBundlesNav();
    if (types.indexOf("bundle") !== -1 || types.indexOf("kit") !== -1) {
      if (!(navBundles && types.indexOf("product") === -1)) {
        chips.push({ key: "sa_type", value: "bundle", label: "Bundles" });
      }
    }
    if (types.indexOf("product") !== -1) {
      chips.push({ key: "sa_type", value: "product", label: "Single products" });
    }
    var minP = params.get("sa_min");
    var maxP = params.get("sa_max");
    if (minP || maxP) {
      var priceLabel =
        minP && maxP
          ? minP + " – " + maxP
          : minP
            ? minP + "+"
            : "Up to " + maxP;
      chips.push({ key: "sa_price", value: "1", label: "Price " + priceLabel });
    }

    var clearBtn = wrap.querySelector(".selfabout-collection__clear");
    chips.forEach(function (chip) {
      var el = document.createElement("span");
      el.className = "selfabout-collection__active-chip";
      el.setAttribute("data-sa-client-chip", chip.key);
      var text = document.createElement("span");
      text.textContent = chip.label;
      var remove = document.createElement("a");
      remove.className = "selfabout-collection__active-chip-remove";
      remove.setAttribute("data-selfabout-filter-link", "");
      remove.setAttribute("data-sa-client-chip-remove", chip.key);
      remove.setAttribute("href", hrefWithoutClientParam(chip.key, chip.value));
      remove.setAttribute("aria-label", "Remove " + chip.label);
      remove.innerHTML = CHIP_REMOVE_ICON;
      el.appendChild(text);
      el.appendChild(remove);
      if (clearBtn) wrap.insertBefore(el, clearBtn);
      else wrap.appendChild(el);
    });
    polishChipRemoveIcons(root);

    var hasShopify = wrap.querySelector(
      ".selfabout-collection__active-chip:not([data-sa-client-chip])",
    );
    var hasClient = chips.length > 0;
    if (hasClient && !clearBtn) {
      var clear = document.createElement("a");
      clear.className = "selfabout-collection__clear";
      clear.setAttribute("data-selfabout-filter-link", "");
      clear.setAttribute("data-sa-client-clear", "");
      clear.textContent = "Clear all";
      var clearHref = window.location.pathname;
      var sort = params.get("sort_by");
      var pageSize = params.get("page_size");
      var cq = new URLSearchParams();
      if (sort) cq.set("sort_by", sort);
      if (pageSize) cq.set("page_size", pageSize);
      if (navBundles) cq.append("sa_type", "bundle");
      var cqs = cq.toString();
      clear.href = cqs ? clearHref + "?" + cqs : clearHref;
      wrap.appendChild(clear);
      clearBtn = clear;
    }

    var any = Boolean(hasShopify) || hasClient;
    if (!any) {
      wrap.querySelectorAll("[data-sa-client-clear]").forEach(function (el) {
        if (el.parentNode) el.parentNode.removeChild(el);
      });
    }
    wrap.hidden = !any;
    wrap.classList.toggle("is-empty", !any);
    if (any) wrap.removeAttribute("hidden");
    else wrap.setAttribute("hidden", "");
  }

  function setFilterActionsLoading(root, busy, which) {
    var form = findFiltersForm(root);
    if (!form) return;
    form.classList.toggle("is-busy", Boolean(busy));
    var applyBtn = form.querySelector(
      '.selfabout-collection__filters-actions button[type="submit"], .selfabout-collection__filters-actions .selfabout-collection__btn--ink',
    );
    var clearBtn = form.querySelector(
      ".selfabout-collection__filters-actions .selfabout-collection__btn--ghost, .selfabout-collection__filters-actions a.selfabout-collection__btn",
    );
    var target = null;
    if (which === "clear") target = clearBtn;
    else if (which === "apply") target = applyBtn;
    else target = applyBtn; /* default: Apply only */

    form.querySelectorAll(
      ".selfabout-collection__filters-actions .selfabout-collection__btn",
    ).forEach(function (btn) {
      ensureFilterBtnChrome(btn);
      var on = Boolean(busy) && btn === target;
      btn.classList.toggle("is-loading", on);
      if (btn.tagName === "BUTTON") {
        /* Keep both disabled while busy so double-submit can't fire */
        btn.disabled = Boolean(busy);
      } else if (busy) {
        btn.setAttribute("aria-disabled", "true");
      } else {
        btn.removeAttribute("aria-disabled");
      }
      if (on) btn.setAttribute("aria-busy", "true");
      else btn.removeAttribute("aria-busy");
    });
  }

  function ensureFilterBtnChrome(btn) {
    if (!btn || btn.querySelector(".selfabout-collection__btn-label")) return;
    var label = document.createElement("span");
    label.className = "selfabout-collection__btn-label";
    while (btn.firstChild) label.appendChild(btn.firstChild);
    if (!(label.textContent || "").trim()) {
      label.textContent = btn.getAttribute("data-label") || "Apply";
    }
    var spin = document.createElement("span");
    spin.className = "selfabout-collection__btn-spinner";
    spin.setAttribute("aria-hidden", "true");
    btn.appendChild(label);
    btn.appendChild(spin);
  }

  function isAvailabilityFacetLabel(text) {
    text = String(text || "")
      .replace(/\d+/g, " ")
      .replace(/\u2026/g, " ")
      .replace(/\s+/g, " ")
      .trim()
      .toLowerCase();
    return text.indexOf("in stock") !== -1 || text.indexOf("out of stock") !== -1;
  }

  function collectionQueryBase(root, options) {
    options = options || {};
    var perPage = Number(root.getAttribute("data-per-page")) || 24;
    var params = new URLSearchParams(window.location.search || "");
    var base = new URLSearchParams();
    params.forEach(function (value, key) {
      if (
        key === "page" ||
        key === "sa_type" ||
        key === "sa_rating" ||
        key === "sa_deal" ||
        key === "sa_stock" ||
        key === "sa_min" ||
        key === "sa_max"
      ) {
        return;
      }
      if (options.ignoreAvailability && /availability/i.test(key)) return;
      base.append(key, value);
    });
    if (!base.get("sort_by")) base.set("sort_by", "created-descending");
    if (perPage) base.set("page_size", String(perPage));
    return { base: base, perPage: perPage };
  }

  function fetchAllCollectionPages(handle, query, perPage) {
    var all = [];
    var page = 1;
    function next() {
      return fetchCollectionPageCards(handle, query, page).then(function (cards) {
        if (!cards.length) return all;
        all = all.concat(cards);
        if (cards.length < perPage || page >= 25) return all;
        page += 1;
        return next();
      });
    }
    return next();
  }

  function cardIsAvailable(card) {
    if (!card) return false;
    var sold = Boolean(
      card.querySelector(".selfabout-collection__badge--sold"),
    );
    return !sold && card.getAttribute("data-available") === "true";
  }

  function scopeCardsForListing(cards, params, ratingsMap) {
    var list = cards || [];
    if (isBundlesPlp()) return list.filter(isKitCard);
    if (hasClientFilters(params)) {
      return list.filter(function (card) {
        return cardPassesClientFilters(card, params, ratingsMap);
      });
    }
    return list;
  }

  /* Facet counts must match apply filters — ignore current sa_stock so In/Out both stay visible */
  function scopeCardsForAvailabilityFacets(cards, params, ratingsMap) {
    var list = cards || [];
    if (isBundlesPlp()) return list.filter(isKitCard);

    var scoped = new URLSearchParams(params.toString());
    scoped.delete("sa_stock");
    if (!hasClientFilters(scoped)) return list;
    return list.filter(function (card) {
      return cardPassesClientFilters(card, scoped, ratingsMap);
    });
  }

  function refreshAvailabilityCounts(root) {
    var form = findFiltersForm(root);
    if (!form) return;
    var options = form.querySelectorAll(".selfabout-collection__facet-option");
    var hasStockFacet = false;
    options.forEach(function (label) {
      if (isAvailabilityFacetLabel(label.textContent)) hasStockFacet = true;
    });
    if (!hasStockFacet) return;

    options.forEach(function (label) {
      var em = label.querySelector("em");
      if (!em || !isAvailabilityFacetLabel(label.textContent)) return;
      em.textContent = "...";
    });

    var params = new URLSearchParams(window.location.search || "");
    var ratingsMap = window.__saCardRatingsMap || null;
    var cacheKey =
      (currentCollectionHandle() || "all") +
      "|avail-local|" +
      (isBundlesPlp() ? "b" : "a") +
      "|" +
      params.getAll("sa_type").sort().join(",") +
      "|" +
      (params.get("sa_rating") || "") +
      "|" +
      params.getAll("sa_deal").sort().join(",") +
      "|" +
      (params.get("sa_min") || "") +
      "|" +
      (params.get("sa_max") || "");

    if (
      root._saAvailCounts &&
      root._saAvailCounts.key === cacheKey &&
      root._saAvailCounts.inStock != null
    ) {
      applyAvailabilityCountLabels(
        form,
        root._saAvailCounts.inStock,
        root._saAvailCounts.outStock,
      );
      return;
    }

    /* Same truth as Apply: card data-available / Sold out badge (not filter.v.availability) */
    loadAllCollectionCards(root, { ignoreAvailability: true })
      .then(function (cards) {
        var list = scopeCardsForAvailabilityFacets(cards, params, ratingsMap);
        var inStock = 0;
        var outStock = 0;
        list.forEach(function (card) {
          if (cardIsAvailable(card)) inStock += 1;
          else outStock += 1;
        });
        root._saAvailCounts = {
          key: cacheKey,
          inStock: inStock,
          outStock: outStock,
        };
        applyAvailabilityCountLabels(form, inStock, outStock);
      })
      .catch(function () {
        applyAvailabilityCountLabels(form, 0, 0);
      });
  }

  function applyAvailabilityCountLabels(form, inStock, outStock) {
    if (!form) return;
    form.querySelectorAll(".selfabout-collection__facet-option").forEach(
      function (label) {
        var em = label.querySelector("em");
        if (!em) return;
        var text = (label.textContent || "")
          .replace(/\d+/g, " ")
          .replace(/\u2026/g, " ")
          .replace(/\s+/g, " ")
          .trim()
          .toLowerCase();
        if (text.indexOf("in stock") !== -1 && text.indexOf("out of") === -1) {
          em.textContent = String(inStock);
        } else if (text.indexOf("out of stock") !== -1) {
          em.textContent = String(outStock);
        }
      },
    );
  }

  /* Back-compat alias */
  function refreshBundleAvailabilityCounts(root) {
    refreshAvailabilityCounts(root);
  }

  function cardHandle(card) {
    if (!card) return "";
    return String(
      card.getAttribute("data-sa-product-handle") ||
      card.getAttribute("data-product-handle") ||
      "",
    )
      .trim()
      .toLowerCase();
  }

  function cardPassesClientFilters(card, params, ratingsMap) {
    var minRating = 0; /* Judge.me migration: SelfAbout sa_rating filter disabled */
    var wantSale = params.getAll("sa_deal").indexOf("sale") !== -1;
    var types = params.getAll("sa_type");
    var wantKit = types.indexOf("bundle") !== -1 || types.indexOf("kit") !== -1;
    var wantProduct = types.indexOf("product") !== -1;
    var stocks = params.getAll("sa_stock");
    var wantIn = stocks.indexOf("in") !== -1;
    var wantOut = stocks.indexOf("out") !== -1;
    var minPrice = Number(params.get("sa_min") || "");
    var maxPrice = Number(params.get("sa_max") || "");
    var hasMin = Number.isFinite(minPrice) && minPrice > 0;
    var hasMax = Number.isFinite(maxPrice) && maxPrice > 0;
    var ok = true;

    if (minRating > 0) {
      var avg = Number(card.getAttribute("data-sa-rating-avg") || 0) || 0;
      var count = Number(card.getAttribute("data-sa-rating-count") || 0) || 0;
      if (ratingsMap) {
        var handle = cardHandle(card);
        var row = handle && ratingsMap[handle];
        if (!row && handle) {
          /* Case / slug fallbacks */
          var keys = Object.keys(ratingsMap);
          for (var i = 0; i < keys.length; i++) {
            if (String(keys[i]).toLowerCase() === handle) {
              row = ratingsMap[keys[i]];
              break;
            }
          }
        }
        if (row) {
          avg = Number(row.average || row.avg || 0) || 0;
          count = Number(row.count || row.total || 0) || 0;
          card.setAttribute("data-sa-rating-avg", String(avg));
          card.setAttribute("data-sa-rating-count", String(count));
        }
      }
      if (minRating >= 3) {
        ok = count > 0 && avg + 0.001 >= minRating;
      } else {
        /* Rated only — any review count */
        ok = count > 0;
      }
    }
    if (ok && wantSale && !isSaleCard(card)) ok = false;
    if (ok && wantIn && wantOut) {
      /* both = no stock restriction */
    } else if (ok && (wantIn || wantOut)) {
      var available = cardIsAvailable(card);
      if (wantIn && !available) ok = false;
      if (ok && wantOut && available) ok = false;
    }
    if (ok && wantKit && wantProduct) {
      /* both = no type restriction */
    } else if (ok && wantKit && !isKitCard(card)) {
      ok = false;
    } else if (ok && wantProduct && isKitCard(card)) {
      ok = false;
    }
    if (ok && (hasMin || hasMax)) {
      var cents = Number(card.getAttribute("data-sa-price-cents") || 0) || 0;
      /* Shopify Liquid price is cents; UI min/max are major currency units */
      var major = cents / 100;
      if (hasMin && major + 0.0001 < minPrice) ok = false;
      if (ok && hasMax && major - 0.0001 > maxPrice) ok = false;
    }
    return ok;
  }

  function rebuildClientPagination(root, total, page, perPage) {
    var wrap = root.querySelector("[data-selfabout-pagination]");
    if (!wrap) return;
    var pages = Math.max(1, Math.ceil(total / perPage));
    var showing = wrap.querySelector("[data-selfabout-showing]");
    var start = total ? (page - 1) * perPage + 1 : 0;
    var end = Math.min(page * perPage, total);
    if (showing) {
      showing.textContent =
        total > 0
          ? "Showing " + start + "–" + end + " of " + total
          : "Showing 0 of 0";
    }
    var nav = wrap.querySelector(".selfabout-collection__pages");
    if (pages <= 1) {
      if (nav) nav.remove();
      return;
    }
    if (!nav) {
      nav = document.createElement("nav");
      nav.className = "selfabout-collection__pages";
      nav.setAttribute("aria-label", "Pagination");
      wrap.appendChild(nav);
    }
    var base = new URL(window.location.href);
    function pageHref(n) {
      var u = new URL(base.href);
      if (n <= 1) u.searchParams.delete("page");
      else u.searchParams.set("page", String(n));
      var qs = u.searchParams.toString();
      return qs ? u.pathname + "?" + qs : u.pathname;
    }
    var html = "";
    if (page > 1) {
      html +=
        '<a class="selfabout-collection__page-btn" href="' +
        pageHref(page - 1) +
        '" data-selfabout-filter-link rel="prev">Prev</a>';
    }
    for (var i = 1; i <= pages; i++) {
      if (i === page) {
        html +=
          '<span class="selfabout-collection__page-btn is-current" aria-current="page">' +
          i +
          "</span>";
      } else if (
        i === 1 ||
        i === pages ||
        (i >= page - 1 && i <= page + 1)
      ) {
        html +=
          '<a class="selfabout-collection__page-btn" href="' +
          pageHref(i) +
          '" data-selfabout-filter-link>' +
          i +
          "</a>";
      } else if (i === page - 2 || i === page + 2) {
        html += '<span class="selfabout-collection__page-btn is-gap">...</span>';
      }
    }
    if (page < pages) {
      html +=
        '<a class="selfabout-collection__page-btn" href="' +
        pageHref(page + 1) +
        '" data-selfabout-filter-link rel="next">Next</a>';
    }
    nav.innerHTML = html;
  }

  function fetchCollectionPageCards(handle, query, page) {
    var q = new URLSearchParams(query);
    if (page > 1) q.set("page", String(page));
    else q.delete("page");
    var qs = q.toString();
    var href =
      "/collections/" + encodeURIComponent(handle || "all") + (qs ? "?" + qs : "");
    return fetch(href, {
      headers: { Accept: "text/html" },
      credentials: "same-origin",
    })
      .then(function (res) {
        if (!res.ok) throw new Error("page " + page);
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        return Array.prototype.slice.call(
          doc.querySelectorAll("[data-selfabout-card]"),
        );
      });
  }

  function loadAllCollectionCards(root, options) {
    options = options || {};
    var handle = currentCollectionHandle() || "all";
    var perPage = Number(root.getAttribute("data-per-page")) || 24;
    var params = new URLSearchParams(window.location.search || "");
    var base = new URLSearchParams();
    params.forEach(function (value, key) {
      if (
        key === "page" ||
        key === "sa_type" ||
        key === "sa_rating" ||
        key === "sa_deal" ||
        key === "sa_stock" ||
        key === "sa_min" ||
        key === "sa_max"
      ) {
        return;
      }
      /* Facet stock counts must see both in/out — strip availability filter */
      if (options.ignoreAvailability && /availability/i.test(key)) return;
      base.append(key, value);
    });
    if (!base.get("sort_by")) base.set("sort_by", "created-descending");
    if (perPage) base.set("page_size", String(perPage));

    var key =
      handle +
      "|" +
      base.toString() +
      "|" +
      perPage +
      (options.ignoreAvailability ? "|facet" : "");
    if (root._saCatalog && root._saCatalog.key === key && root._saCatalog.cards) {
      return Promise.resolve(root._saCatalog.cards);
    }
    if (root._saCatalogPromise && root._saCatalogPromiseKey === key) {
      return root._saCatalogPromise;
    }

    var all = [];
    var page = 1;
    function next() {
      return fetchCollectionPageCards(handle, base, page).then(function (cards) {
        if (!cards.length) return all;
        all = all.concat(cards);
        if (cards.length < perPage || page >= 25) return all;
        page += 1;
        return next();
      });
    }

    root._saCatalogPromiseKey = key;
    root._saCatalogPromise = next()
      .then(function (cards) {
        root._saCatalog = { key: key, cards: cards };
        return cards;
      })
      .finally(function () {
        root._saCatalogPromise = null;
        root._saCatalogPromiseKey = "";
      });
    return root._saCatalogPromise;
  }

  function applyClientFilters(root) {
    var params = new URLSearchParams(window.location.search);
    /* Bundles PLP: strip non-kits before any async catalog fetch paints */
    if (isBundlesPlp()) pruneNonBundleCards(root);

    if (!hasClientFilters(params)) {
      root.querySelectorAll("[data-selfabout-card].is-sa-filtered-out").forEach(
        function (card) {
          card.classList.remove("is-sa-filtered-out");
        },
      );
      return Promise.resolve();
    }

    if (root._saApplyingFilters) return root._saApplyingFilters;

    var perPage = Number(root.getAttribute("data-per-page")) || 24;
    var page = Math.max(1, Number(params.get("page") || 1) || 1);
    var ratingsMap = window.__saCardRatingsMap || null;
    var needsRatings = Boolean(params.get("sa_rating"));

    /* Don't empty the grid before ratings map is ready */
    if (needsRatings && !ratingsMap) {
      return Promise.resolve();
    }

    var grid = root.querySelector("[data-selfabout-collection-grid]");
    var countEl = root.querySelector("[data-selfabout-result-count]");

    root._saApplyingFilters = loadAllCollectionCards(root)
      .then(function (cards) {
        var matched = cards.filter(function (card) {
          return cardPassesClientFilters(card, params, ratingsMap);
        });
        var total = matched.length;
        var maxPage = Math.max(1, Math.ceil(total / perPage) || 1);
        if (page > maxPage) page = maxPage;
        var start = (page - 1) * perPage;
        var slice = matched.slice(start, start + perPage);
        var sig =
          matched
            .map(function (card) {
              return cardHandle(card);
            })
            .join(",") +
          "|" +
          page +
          "|" +
          perPage +
          "|" +
          (ratingsMap ? "r" : "0");
        if (root._saFilterRenderSig === sig) return;
        root._saFilterRenderSig = sig;

        if (grid) {
          grid.innerHTML = "";
          slice.forEach(function (card, index) {
            var node = card.cloneNode(true);
            node.classList.remove("is-sa-filtered-out");
            node.classList.add("sa-reveal", "is-in");
            node.style.setProperty(
              "--sa-reveal-delay",
              Math.min(index, 8) * 40 + "ms",
            );
            grid.appendChild(node);
          });
          if (!slice.length) {
            var empty = root.querySelector("[data-selfabout-empty]");
            if (!empty) {
              empty = document.createElement("div");
              empty.className = "selfabout-collection__empty sa-reveal is-in";
              empty.setAttribute("data-selfabout-empty", "");
              empty.innerHTML =
                "<h2>No matches</h2><p>Clear filters or try another.</p>";
              if (grid.parentNode) {
                grid.parentNode.insertBefore(empty, grid);
              }
            }
            empty.hidden = false;
            grid.hidden = true;
          } else {
            var existingEmpty = root.querySelector("[data-selfabout-empty]");
            if (existingEmpty) existingEmpty.hidden = true;
            grid.hidden = false;
          }
        }

        if (countEl) {
          countEl.textContent = total + (total === 1 ? " item" : " items");
        }
        rebuildClientPagination(root, total, page, perPage);
        preserveClientParamsOnLinks(root);
        bindCardActions(root);
        fixBrokenCardImages(root);
        syncSaveButtons(root);
        refreshCartUi(root).catch(function () { });
      })
      .catch(function () {
        var visible = 0;
        root.querySelectorAll("[data-selfabout-card]").forEach(function (card) {
          var ok = cardPassesClientFilters(card, params, ratingsMap);
          card.classList.toggle("is-sa-filtered-out", !ok);
          if (ok) visible += 1;
        });
        if (countEl) {
          countEl.textContent =
            visible +
            (visible === 1 ? " item" : " items") +
            " on this page";
        }
      })
      .finally(function () {
        root._saApplyingFilters = null;
      });

    return root._saApplyingFilters;
  }

  function measureFixedChromeBottom() {
    /* Mobile: navbar row is 56px; pin at 64px for a small gap under the bar. */
    var isMobile =
      !!(window.matchMedia && window.matchMedia("(max-width:899px)").matches);
    if (isMobile) return 64;

    var row = document.querySelector(
      "#header-component .header__columns, header-component .header__columns, " +
        "#header-component .header__row, header-component .header__row",
    );
    if (row) {
      var rr = row.getBoundingClientRect();
      if (rr.height >= 40 && rr.bottom > 40) return Math.round(rr.bottom);
    }
    var hdr = document.querySelector("#header-component, header-component");
    if (hdr) {
      var hr = hdr.getBoundingClientRect();
      if (hr.height >= 40 && hr.bottom > 40) return Math.round(hr.bottom);
    }
    return 72;
  }

  function syncStickyOffset(root) {
    var value;
    var scrollEl = document.getElementById("sa-content-scroll");
    var docMode =
      scrollEl && scrollEl.getAttribute("data-sa-scroll-mode") === "document";
    var isMobile =
      !!(window.matchMedia && window.matchMedia("(max-width:899px)").matches);

    if (isMobile || docMode) {
      value = "64px";
    } else if (scrollEl) {
      value = "12px";
    } else {
      var themeHeader = (
        getComputedStyle(document.documentElement).getPropertyValue("--header-height") ||
        ""
      ).trim();
      if (themeHeader && themeHeader !== "0px") {
        value = "calc(" + themeHeader + " + 8px)";
      } else {
        value = "72px";
      }
    }
    document.documentElement.style.setProperty("--sa-sticky-top", value);
    if (root) root.style.setProperty("--sa-sticky-top", value);
  }

  function parseStickyTopPx(root) {
    var raw = (
      (root && getComputedStyle(root).getPropertyValue("--sa-sticky-top")) ||
      getComputedStyle(document.documentElement).getPropertyValue("--sa-sticky-top") ||
      "12px"
    ).trim();
    if (raw.indexOf("calc") !== -1) {
      return measureFixedChromeBottom();
    }
    var n = parseFloat(raw);
    return Number.isFinite(n) ? n : 12;
  }

  function toolbarPinId(root) {
    return (root && root.id) || "selfabout-collection";
  }

  function findToolbar(root, slot) {
    var id = toolbarPinId(root);
    /* Prefer pinned (visible) toolbar — slot copy can be stale after pin */
    var pinned = document.querySelector(
      'body > [data-selfabout-collection-toolbar][data-sa-pin-for="' + id + '"]',
    );
    if (pinned) return pinned;
    if (slot) {
      var local = slot.querySelector("[data-selfabout-collection-toolbar]");
      if (local) return local;
    }
    return null;
  }

  /** Toolbar may be portaled to body while pinned — query active bar first, then root. */
  function toolbarScope(root) {
    var parts = [];
    var bar = findToolbar(
      root,
      root && root.querySelector("[data-selfabout-toolbar-slot]"),
    );
    if (bar) parts.push(bar);
    if (root && parts.indexOf(root) === -1) parts.push(root);
    return parts;
  }

  function queryToolbar(root, selector) {
    var scopes = toolbarScope(root);
    for (var i = 0; i < scopes.length; i++) {
      var hit = scopes[i].querySelector(selector);
      if (hit) return hit;
    }
    return null;
  }

  function queryToolbarAll(root, selector) {
    var seen = [];
    var out = [];
    toolbarScope(root).forEach(function (scope) {
      scope.querySelectorAll(selector).forEach(function (el) {
        if (seen.indexOf(el) !== -1) return;
        seen.push(el);
        out.push(el);
      });
    });
    return out;
  }

  function isToolbarControl(root, el) {
    if (!el) return false;
    if (root && root.contains(el)) return true;
    var bar = el.closest && el.closest("[data-selfabout-collection-toolbar]");
    if (!bar) return false;
    var pinFor = bar.getAttribute("data-sa-pin-for");
    if (!pinFor) return !!findToolbar(root, root && root.querySelector("[data-selfabout-toolbar-slot]"));
    return pinFor === toolbarPinId(root);
  }

  function clearToolbarPinStyles(toolbar) {
    if (!toolbar) return;
    toolbar.style.top = "";
    toolbar.style.left = "";
    toolbar.style.width = "";
    toolbar.style.right = "";
    toolbar.style.zIndex = "";
    toolbar.style.pointerEvents = "";
    toolbar.style.transform = "";
    toolbar.style.opacity = "";
    toolbar.style.transition = "";
    toolbar.removeAttribute("data-sa-pin-w");
  }

  /**
   * Returns the CONTENT-AREA bounds of the toolbar's parent shell element.
   * This is the precise left offset and width the toolbar should occupy when
   * pinned (position:fixed), matching the shell's clamp()-padded content area.
   *
   * Using the slot's getBoundingClientRect() alone is unreliable because the
   * slot width can equal the full scroll-container width (including the scrollbar
   * gutter) on the first paint, before the gutter reserve settles.
   *
   * @param {Element} slot  The [data-selfabout-toolbar-slot] element
   * @returns {{ left: number, width: number } | null}
   */
  function toolbarShellBounds(slot) {
    var shell = slot && slot.parentElement;
    if (!shell) return null;
    var r = shell.getBoundingClientRect();
    var s = window.getComputedStyle(shell);
    var pl = parseFloat(s.paddingLeft) || 0;
    var pr = parseFloat(s.paddingRight) || 0;
    return { left: r.left + pl, width: r.width - pl - pr };
  }

  function toolbarScrollTop() { return window.scrollY || document.documentElement.scrollTop || (document.getElementById("sa-content-scroll") ? document.getElementById("sa-content-scroll").scrollTop : 0) || 0; }

  var __saToolbarScrollY = null;

  function noteToolbarScrollY() {
    __saToolbarScrollY = toolbarScrollTop();
    return __saToolbarScrollY;
  }

  function unpinToolbar(root) {
    var slot = root && root.querySelector("[data-selfabout-toolbar-slot]");
    var toolbar = findToolbar(root, slot);
    if (!toolbar) return;
    /* Snap fixed bar onto the in-flow slot BEFORE clearing fixed —
       avoids a frame stuck at pinTop after a fast scroll-to-top. */
    if (slot && toolbar.classList.contains("is-pinned")) {
      var snap = slot.getBoundingClientRect();
      toolbar.style.top = snap.top + "px";
      toolbar.style.left = snap.left + "px";
      toolbar.style.width = snap.width + "px";
      toolbar.style.right = "auto";
    }
    toolbar.classList.remove("is-pinned", "is-pin-enter", "is-unpinning");
    clearToolbarPinStyles(toolbar);
    toolbar.removeAttribute("data-sa-pin-for");
    if (slot && toolbar.parentElement !== slot) {
      slot.appendChild(toolbar);
    }
    if (slot) slot.style.height = "";
  }

  function syncToolbarPin(root) {
    if (!root) return;
    /* Never re-pin while filter / quick-view sheet is open */
    try {
      if (
        document.documentElement.classList.contains("sa-plp-overlay-open") ||
        findPlpOverlay(root, "[data-selfabout-filters].is-open") ||
        findPlpOverlay(root, "[data-selfabout-qv].is-open") ||
        root.querySelector(
          ".selfabout-collection__filters.is-open, [data-selfabout-filters].is-open, .selfabout-collection__qv.is-open, [data-selfabout-qv].is-open",
        )
      ) {
        unpinToolbar(root);
        return;
      }
    } catch (_ov) {}
    var slot = root.querySelector("[data-selfabout-toolbar-slot]");
    if (!slot) return;
    var toolbar = findToolbar(root, slot);
    if (!toolbar) return;

    var scrollEl = document.getElementById("sa-content-scroll");
    var offset = parseStickyTopPx(root);
    /* Only use scrollEl.getBoundingClientRect().top when the desktop shell scrolls
       (mode=shell). Mobile document mode uses display:contents — its rect is 0 or
       inflated by page-wrapper padding, which left a large gap under the fixed nav. */
    var shellActive = document.documentElement.classList.contains("sa-content-scroll");
    var docMode =
      scrollEl && scrollEl.getAttribute("data-sa-scroll-mode") === "document";
    var isMobile =
      !!(window.matchMedia && window.matchMedia("(max-width:899px)").matches);
    var pinTop;
    if (isMobile || docMode) {
      pinTop = 64;
      document.documentElement.style.setProperty("--sa-sticky-top", "64px");
      if (root) root.style.setProperty("--sa-sticky-top", "64px");
    } else if (scrollEl && shellActive) {
      pinTop = scrollEl.getBoundingClientRect().top + 8;
    } else {
      pinTop = offset;
    }
    /* Measure the in-flow slot (placeholder while pinned) — never the floating bar */
    var slotRect = slot.getBoundingClientRect();
    var isPinned =
      toolbar.classList.contains("is-pinned") &&
      toolbar.parentElement === document.body;
    /*
     * Classic sticky:
     * - Pin while the natural slot is above the pin line (browsing products)
     * - Stay pinned on scroll-up too
     * - Unpin only when the slot returns to/below the pin line (home)
     * Small hysteresis when pinned avoids threshold flicker.
     */
    var shouldPin = isPinned
      ? slotRect.top <= pinTop + 2
      : slotRect.top <= pinTop + 0.5;

    if (shouldPin) {
      if (!isPinned) {
        /* Snapshot the toolbar's OWN rect BEFORE adding .is-pinned so the
           fixed/portaled width exactly matches the natural in-flow width.
           Use shell content-area measurements (paddingLeft/Right) rather than
           slotRect alone, which can include scrollbar gutter width. */
        var toolbarOwnRect = toolbar.getBoundingClientRect();
        var height = Math.ceil(toolbarOwnRect.height || slotRect.height || 64);
        var shellBounds = toolbarShellBounds(slot);
        var ownLeft = shellBounds ? shellBounds.left : slotRect.left;
        var ownWidth = shellBounds ? shellBounds.width : (toolbarOwnRect.width || slotRect.width);
        slot.style.height = height + "px";
        toolbar.setAttribute("data-sa-pin-for", toolbarPinId(root));
        /* Cache width so DevTools / diagnostics can inspect it */
        toolbar.setAttribute("data-sa-pin-w", String(ownWidth));
        /* Apply fixed geometry before portal — avoids a 1-frame flash at (0,0) */
        toolbar.classList.add("is-pinned");
        toolbar.style.setProperty("top", pinTop + "px", "important");
        toolbar.style.left = ownLeft + "px";
        toolbar.style.width = ownWidth + "px";
        toolbar.style.right = "auto";
        toolbar.style.zIndex = "200";
        toolbar.style.pointerEvents = "auto";
        toolbar.style.opacity = "1";
        toolbar.style.transform = "none";
        /* Escape #sa-content-scroll overflow — fixed inside it fails hit-testing */
        document.body.appendChild(toolbar);
      } else {
        /* Already pinned — re-derive shell content area on every scroll/resize tick.
           This correctly handles viewport resize without needing a separate resize
           handler, and avoids any stale cached values. */
        var shellBounds = toolbarShellBounds(slot);
        slotRect = slot.getBoundingClientRect();
        toolbar.style.setProperty("top", pinTop + "px", "important");
        toolbar.style.left = (shellBounds ? shellBounds.left : slotRect.left) + "px";
        toolbar.style.width = (shellBounds ? shellBounds.width : (parseFloat(toolbar.getAttribute("data-sa-pin-w")) || slotRect.width)) + "px";
        toolbar.style.right = "auto";
        toolbar.style.zIndex = "200";
        toolbar.style.pointerEvents = "auto";
      }
    } else if (isPinned || toolbar.classList.contains("is-pinned")) {
      unpinToolbar(root);
    }
  }

  function syncAllToolbarPins() {
    noteToolbarScrollY();
    document.querySelectorAll("[data-selfabout-collection]").forEach(function (root) {
      syncStickyOffset(root);
      syncToolbarPin(root);
    });
  }

  function bindToolbarPin() {
    if (bindToolbarPin.bound) return;
    bindToolbarPin.bound = true;
    var ticking = false;
    var onScroll = function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        syncAllToolbarPins();
      });
    };
    var onScrollEnd = function () {
      syncAllToolbarPins();
    };
    var scrollEl = document.getElementById("sa-content-scroll");
    if (scrollEl) {
      scrollEl.addEventListener("scroll", onScroll, { passive: true });
      scrollEl.addEventListener("scrollend", onScrollEnd, { passive: true });
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("scrollend", onScrollEnd, { passive: true });
    window.addEventListener("resize", onScroll);
  }

  function syncControlsFromUrl(root) {
    var params = new URLSearchParams(window.location.search);
    var sortBy = params.get("sort_by");
    if (sortBy) {
      queryToolbarAll(root, "[data-selfabout-sort]").forEach(function (select) {
        if (
          select.querySelector(
            'option[value="' + String(sortBy).replace(/"/g, "") + '"]',
          )
        ) {
          select.value = sortBy;
        }
      });
    }
    var pageSize = params.get("page_size");
    if (pageSize) {
      applyPageSize(root, pageSize);
      return;
    }
    var rendered = root.getAttribute("data-per-page");
    if (rendered) applyPageSize(root, rendered);
  }

  function polishSortOptions(root) {
    var priority = [
      "created-descending",
      "created-ascending",
      "best-selling",
      "price-ascending",
      "price-descending",
      "title-ascending",
      "title-descending",
      "manual",
    ];
    queryToolbarAll(root, "[data-selfabout-sort]").forEach(function (select) {
      if (!select || select.getAttribute("data-sa-sort-ordered") === "1") return;
      var byValue = {};
      Array.prototype.slice.call(select.options).forEach(function (opt) {
        if (!byValue[opt.value]) byValue[opt.value] = opt;
      });
      var current =
        new URLSearchParams(window.location.search).get("sort_by") ||
        select.value ||
        "";
      select.innerHTML = "";
      priority.forEach(function (value) {
        if (byValue[value]) {
          select.appendChild(byValue[value]);
          delete byValue[value];
        }
      });
      Object.keys(byValue).forEach(function (value) {
        select.appendChild(byValue[value]);
      });
      select.setAttribute("data-sa-sort-ordered", "1");
      if (current && select.querySelector('option[value="' + current + '"]')) {
        select.value = current;
      } else if (select.querySelector('option[value="created-descending"]')) {
        select.value = "created-descending";
      }
    });
  }

  function updateCartBadge(itemCount) {
    if (window.SelfAboutCart && window.SelfAboutCart.updateCartBadge) {
      window.SelfAboutCart.updateCartBadge(itemCount);
      return;
    }
    var count = Math.max(0, Number(itemCount) || 0);
    try {
      sessionStorage.setItem(
        "cart-count",
        JSON.stringify({ value: String(count), timestamp: Date.now() }),
      );
    } catch (_e) {
      /* private mode */
    }

    document.dispatchEvent(
      new CustomEvent("cart:update", {
        bubbles: true,
        detail: {
          data: {
            itemCount: count,
            source: "selfabout-collection",
          },
        },
      }),
    );
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:refresh", { bubbles: true }),
    );

    var icon = document.querySelector("cart-icon");
    if (icon) {
      try {
        if (typeof icon.renderCartBubble === "function") {
          icon.renderCartBubble(count, false);
        } else if ("currentCartCount" in icon) {
          icon.currentCartCount = count;
          icon.classList.toggle("header-actions__cart-icon--has-cart", count > 0);
        }
      } catch (_err) {
        /* theme API differences */
      }
    }

    document
      .querySelectorAll(
        "[ref='cartBubbleCount'], .cart-bubble__text-count, [data-testid='cart-bubble'], .cart-bubble-count, .cart-count-bubble span[aria-hidden='true'], .cart-count-bubble > span",
      )
      .forEach(function (node) {
        if (!node || node.closest("cart-icon")) return;
        node.textContent = count > 99 ? "" : String(count);
        node.classList.toggle("hidden", count === 0);
        var bubble = node.closest(".cart-bubble, .cart-count-bubble");
        if (bubble) {
          bubble.classList.toggle("visually-hidden", count === 0);
          bubble.classList.toggle("hidden", count === 0);
          if (count > 0) bubble.classList.remove("visually-hidden", "hidden");
          bubble.classList.remove("cart-bubble--animating");
          if (count > 0 && !reducedMotion) {
            bubble.classList.add("cart-bubble--animating");
            window.setTimeout(function () {
              bubble.classList.remove("cart-bubble--animating");
            }, 600);
          }
        }
      });

    document
      .querySelectorAll(".header-actions__cart-icon, .header__icon--cart")
      .forEach(function (el) {
        if (el.closest("cart-icon") || el.tagName === "CART-ICON") return;
        el.classList.toggle("header-actions__cart-icon--has-cart", count > 0);
      });
  }

  function openSelfAboutDrawer(cart) {
    if (window.SelfAboutCart && window.SelfAboutCart.openDrawer) {
      window.SelfAboutCart.openDrawer({ source: "plp", cart: cart || null });
    }
  }

  function notifyCartUpdated(cartOrPayload) {
    var count =
      cartOrPayload && typeof cartOrPayload.item_count === "number"
        ? cartOrPayload.item_count
        : cartOrPayload &&
          cartOrPayload.data &&
          typeof cartOrPayload.data.itemCount === "number"
          ? cartOrPayload.data.itemCount
          : null;
    if (count == null) {
      fetchCart()
        .then(function (cart) {
          updateCartBadge(cart.item_count);
        })
        .catch(function () { });
      return;
    }
    updateCartBadge(count);
  }

  function flyToCart(fromEl) {
    if (reducedMotion || !fromEl) return;
    var cart =
      document.querySelector("cart-icon") ||
      document.querySelector("[href*='/cart']") ||
      document.querySelector(".header__icon--cart");
    if (!cart) return;
    var from = fromEl.getBoundingClientRect();
    var to = cart.getBoundingClientRect();
    var dot = document.createElement("span");
    dot.className = "selfabout-collection__fly";
    dot.style.transform =
      "translate(" +
      (from.left + from.width / 2 - 6) +
      "px," +
      (from.top + from.height / 2 - 6) +
      "px)";
    document.body.appendChild(dot);
    requestAnimationFrame(function () {
      dot.style.transition =
        "transform 620ms cubic-bezier(0.22, 1, 0.36, 1), opacity 620ms ease";
      dot.style.transform =
        "translate(" +
        (to.left + to.width / 2 - 6) +
        "px," +
        (to.top + to.height / 2 - 6) +
        "px) scale(0.4)";
      dot.style.opacity = "0.15";
    });
    window.setTimeout(function () {
      if (dot.parentNode) dot.parentNode.removeChild(dot);
    }, 700);
  }

  function setButtonLoading(button, loading) {
    if (!button) return;
    button.classList.toggle("is-loading", Boolean(loading));
    button.classList.toggle("is-busy", Boolean(loading));
    button.disabled = Boolean(loading);
  }

  function setButtonSuccess(button, label, restoreLabel) {
    button.classList.remove("is-loading", "is-busy");
    button.disabled = false;
    button.classList.add("is-success");
    var text = button.querySelector(".selfabout-collection__btn-label");
    if (text) text.textContent = label;
    else button.textContent = label;
    window.setTimeout(function () {
      button.classList.remove("is-success");
      if (restoreLabel) {
        if (text) text.textContent = restoreLabel;
        else button.textContent = restoreLabel;
      }
    }, 900);
  }

  var HORIZON_VIEWED_KEY = "viewedProducts";
  var SELFABOUT_VIEWED_KEY = "selfabout_recently_viewed";

  function getHorizonViewedIds() {
    try {
      var parsed = JSON.parse(
        window.localStorage.getItem(HORIZON_VIEWED_KEY) || "[]",
      );
      return Array.isArray(parsed) ? parsed.map(String) : [];
    } catch (_e) {
      return [];
    }
  }

  function pushHorizonViewedId(productId) {
    if (!productId) return;
    var id = String(productId);
    var next = getHorizonViewedIds().filter(function (item) {
      return item !== id;
    });
    next.unshift(id);
    try {
      window.localStorage.setItem(
        HORIZON_VIEWED_KEY,
        JSON.stringify(next.slice(0, 8)),
      );
    } catch (_e) {
      /* private mode */
    }
  }

  function pushSelfaboutViewed(item, options) {
    if (!item || !item.handle) return;
    var next = readJson(SELFABOUT_VIEWED_KEY).filter(function (entry) {
      return entry && entry.handle !== item.handle;
    });
    next.unshift({
      handle: item.handle,
      title: item.title || item.handle,
      url: item.url || "/products/" + item.handle,
      image: item.image || null,
      price: item.price || "",
      id: item.id || null,
    });
    writeJson(SELFABOUT_VIEWED_KEY, next.slice(0, 12));
    if (options && options.silent) return;
    try {
      document.dispatchEvent(
        new CustomEvent("selfabout:recently-viewed", {
          detail: { key: SELFABOUT_VIEWED_KEY, items: next.slice(0, 12) },
        }),
      );
    } catch (_e) { }
  }

  var affinityRefreshQueued = false;
  function refreshPlpAffinity() {
    if (affinityRefreshQueued) return;
    affinityRefreshQueued = true;
    window.requestAnimationFrame(function () {
      affinityRefreshQueued = false;
      document.querySelectorAll("[data-selfabout-collection]").forEach(function (root) {
        initAffinity(root);
      });
    });
  }

  function trackCardView(card) {
    if (!card) return;
    var id = card.getAttribute("data-product-id");
    var handle = card.getAttribute("data-product-handle");
    var saveBtn = card.querySelector("[data-selfabout-save]");
    pushHorizonViewedId(id);
    pushSelfaboutViewed({
      id: id,
      handle: handle || (saveBtn && saveBtn.getAttribute("data-handle")),
      title: saveBtn && saveBtn.getAttribute("data-title"),
      url: saveBtn && saveBtn.getAttribute("data-url"),
      image: saveBtn && saveBtn.getAttribute("data-image"),
      price: saveBtn && saveBtn.getAttribute("data-price"),
    });
  }

  function trackSiblingClick(link) {
    try {
      var endpoint = "/apps/selfabout/events";
      var shop =
        (window.Shopify && window.Shopify.shop) ||
        document.documentElement.getAttribute("data-shop") ||
        "";
      var url = endpoint + (shop ? "?shop=" + encodeURIComponent(shop) : "");
      var current =
        document.querySelector("[data-selfabout-collection]") &&
        (window.location.pathname.match(/\/collections\/([^/?#]+)/) || [])[1];
      var payload = JSON.stringify({
        name: "sa_sibling_collection_click",
        properties: {
          from: current || "",
          to: (link && link.getAttribute("data-handle")) || "",
          surface: "collection_plp",
        },
        occurredAt: new Date().toISOString(),
      });
      if (navigator.sendBeacon) {
        navigator.sendBeacon(url, new Blob([payload], { type: "application/json" }));
      }
    } catch (_e) { }
  }

  function mapSuggestProduct(product) {
    if (!product) return null;
    var handle = product.handle;
    var url = product.url || (handle ? "/products/" + handle : null);
    if (!handle && url) {
      var match = String(url).match(/\/products\/([^/?#]+)/);
      handle = match && match[1];
    }
    if (!handle || !url) return null;
    var image =
      product.image ||
      (product.featured_image &&
        (product.featured_image.url || product.featured_image)) ||
      null;
    var priceLabel = "";
    var off = 0;
    if (product.price != null || product.price_min != null) {
      var raw = product.price != null ? product.price : product.price_min;
      var num = Number(raw);
      if (Number.isFinite(num)) {
        if (
          Number.isInteger(num) &&
          num >= 100 &&
          String(raw).indexOf(".") === -1
        ) {
          num = num / 100;
        }
        try {
          priceLabel = new Intl.NumberFormat(undefined, {
            style: "currency",
            currency:
              (window.Shopify &&
                window.Shopify.currency &&
                window.Shopify.currency.active) ||
              "USD",
          }).format(num);
        } catch (_e) {
          priceLabel = String(raw);
        }
      }
    }
    var compareRaw =
      product.compare_at_price_max != null
        ? product.compare_at_price_max
        : product.compare_at_price != null
          ? product.compare_at_price
          : product.compare_at_price_min;
    if (compareRaw != null && (product.price != null || product.price_min != null)) {
      var priceCents = Number(
        product.price != null ? product.price : product.price_min,
      );
      var compareCents = Number(compareRaw);
      if (Number.isFinite(priceCents) && Number.isFinite(compareCents)) {
        if (
          Number.isInteger(priceCents) &&
          priceCents >= 100 &&
          String(product.price != null ? product.price : product.price_min).indexOf(
            ".",
          ) === -1
        ) {
          /* already cents */
        } else {
          priceCents = Math.round(priceCents * 100);
          compareCents = Math.round(compareCents * 100);
        }
        if (compareCents > priceCents && compareCents > 0) {
          off = Math.max(
            1,
            Math.round(((compareCents - priceCents) / compareCents) * 100),
          );
        }
      }
    }
    return {
      handle: handle,
      title: product.title || handle,
      url: url,
      image: image,
      price: priceLabel,
      off: off,
      id: product.id != null ? String(product.id) : null,
    };
  }

  function renderAffinityItems(rail, empty, items) {
    rail.innerHTML = "";
    rail.hidden = false;
    rail.removeAttribute("hidden");
    rail.style.removeProperty("display");
    var block = rail.closest("[data-selfabout-plp-affinity]");
    if (block) revealPlpAffinityBlock(block);
    if (!items.length) {
      if (empty) {
        empty.hidden = false;
        empty.removeAttribute("hidden");
        empty.style.removeProperty("display");
        if (!empty.querySelector(".sa-affinity-empty-heading")) {
          empty.innerHTML =
            '<p class="sa-affinity-empty-heading">Nothing here yet</p>' +
            '<p class="sa-affinity-empty-sub">Products you open will show up here for quick return.</p>';
        }
      }
      return;
    }
    if (empty) {
      empty.hidden = true;
      empty.setAttribute("hidden", "");
    }
    items.forEach(function (item) {
      var article = document.createElement("article");
      article.className = "selfabout-collection__affinity-card";
      if (item.handle) {
        article.setAttribute("data-sa-product-handle", item.handle);
      }
      var off = Number(item.off) || 0;
      if (off > 0) {
        article.setAttribute("data-sa-off", String(off));
      }
      var link = document.createElement("a");
      link.href = item.url;
      if (item.image) {
        var img = document.createElement("img");
        img.src = item.image;
        img.alt = "";
        img.width = 180;
        img.height = 180;
        img.loading = "lazy";
        link.appendChild(img);
      }
      if (off > 0) {
        var badge = document.createElement("span");
        badge.className = "sa-card-off";
        badge.setAttribute("data-sa-card-off", String(off));
        badge.setAttribute("aria-label", off + "% off");
        badge.textContent = "-" + off + "%";
        link.appendChild(badge);
      }
      var strong = document.createElement("strong");
      strong.textContent = item.title || item.handle;
      link.appendChild(strong);
      if (item.price) {
        var em = document.createElement("em");
        em.textContent = item.price;
        link.appendChild(em);
      }
      var offerSlot = document.createElement("span");
      offerSlot.className = "sa-offer-cart sa-offer-cart--card";
      offerSlot.setAttribute("data-sa-offer-cart-slot", "");
      offerSlot.hidden = true;
      link.appendChild(offerSlot);
      var shipSlot = document.createElement("span");
      shipSlot.className = "sa-offer-ship sa-offer-ship--card";
      shipSlot.setAttribute("data-sa-offer-ship-slot", "");
      shipSlot.hidden = true;
      link.appendChild(shipSlot);
      article.appendChild(link);
      rail.appendChild(article);
    });
    try {
      document.dispatchEvent(
        new CustomEvent("selfabout:dom-updated", { detail: { root: rail } }),
      );
    } catch (_e) { }
  }

  function fetchHorizonViewedProducts(ids, limit) {
    var sliced = ids.slice(0, limit);
    if (!sliced.length) return Promise.resolve([]);
    var params = new URLSearchParams();
    params.set(
      "q",
      sliced
        .map(function (id) {
          return "id:" + id;
        })
        .join(" OR "),
    );
    params.set("resources[type]", "product");
    params.set("resources[limit]", String(Math.max(sliced.length, limit)));
    return fetch("/search/suggest.json?" + params.toString(), {
      headers: { Accept: "application/json" },
      credentials: "same-origin",
    })
      .then(function (res) {
        if (!res.ok) throw new Error("suggest failed");
        return res.json();
      })
      .then(function (data) {
        var products =
          (data &&
            data.resources &&
            data.resources.results &&
            data.resources.results.products) ||
          [];
        var byId = {};
        products.forEach(function (product) {
          var mapped = mapSuggestProduct(product);
          if (!mapped) return;
          if (mapped.id) byId[mapped.id] = mapped;
          byId[mapped.handle] = mapped;
        });
        return sliced
          .map(function (id) {
            return byId[String(id)];
          })
          .filter(Boolean)
          .slice(0, limit);
      })
      .catch(function () {
        return [];
      });
  }

  /* Drive html.sa-plp-overlay-open so mobile bottom-nav hides like cart/drawer */
  function findPlpOverlay(root, selector) {
    if (!root) return null;
    /* Portaled copy is the live one — an in-root match can be freshly
       rendered markup while the open sheet still sits on <body>. */
    var id = toolbarPinId(root);
    var portaled = null;
    try {
      portaled = document.querySelector(
        'body > ' + selector + '[data-sa-portaled-for="' + id + '"]',
      );
    } catch (_e) {
      portaled = null;
    }
    return portaled || root.querySelector(selector);
  }

  /** Escape #sa-content-scroll stacking so fixed overlays beat sticky header (iOS Safari). */
  function portalPlpOverlay(root, el) {
    if (!el || !root) return;
    if (el.parentElement === document.body) {
      el.setAttribute("data-sa-portaled-for", toolbarPinId(root));
      return;
    }
    if (!el.__saPortalParent) el.__saPortalParent = el.parentNode;
    el.setAttribute("data-sa-portaled-for", toolbarPinId(root));
    el.setAttribute("data-sa-portaled", "1");
    document.body.appendChild(el);
  }

  function unportalPlpOverlay(el) {
    if (!el) return;
    var home = el.__saPortalParent;
    try {
      if (home && el.parentElement === document.body) home.appendChild(el);
    } catch (_e) {}
    el.__saPortalParent = null;
    el.removeAttribute("data-sa-portaled-for");
    el.removeAttribute("data-sa-portaled");
  }

  /* Soft-nav: close + return portaled sheets to the PLP shell — never removeChild
     (destroying markup made Filter permanently dead for the page lifetime). */
  function discardPortaledOverlays(root) {
    var stale = [];
    try {
      if (root) {
        stale = Array.prototype.slice.call(
          document.querySelectorAll(
            'body > [data-sa-portaled-for="' + toolbarPinId(root) + '"]',
          ),
        );
      }
      var orphans = document.querySelectorAll(
        "body > [data-selfabout-filter-backdrop], body > [data-selfabout-filters], body > [data-selfabout-qv], body > [data-selfabout-qv-backdrop]",
      );
      for (var oi = 0; oi < orphans.length; oi++) {
        if (stale.indexOf(orphans[oi]) < 0) stale.push(orphans[oi]);
      }
    } catch (_e) {
      return;
    }
    if (!stale.length) {
      document.documentElement.classList.remove("sa-plp-overlay-open");
      return;
    }
    stale.forEach(function (el) {
      el.classList.remove("is-open");
      el.hidden = true;
      el.setAttribute("aria-hidden", "true");
      try {
        el.style.setProperty("pointer-events", "none", "important");
        el.style.removeProperty("display");
        el.style.removeProperty("opacity");
        el.style.removeProperty("visibility");
      } catch (_s) {}
      unportalPlpOverlay(el);
    });
    document.documentElement.classList.remove("sa-plp-overlay-open");
    lockScroll(false);
  }

  function syncPlpOverlayChrome(root) {
    try {
      var panel =
        (root && findPlpOverlay(root, "[data-selfabout-filters]")) ||
        document.querySelector(
          "body > [data-selfabout-filters].is-open, [data-selfabout-collection] [data-selfabout-filters].is-open",
        );
      var qv =
        (root && findPlpOverlay(root, "[data-selfabout-qv]")) ||
        document.querySelector(
          "body > [data-selfabout-qv].is-open, [data-selfabout-collection] [data-selfabout-qv].is-open",
        );
      var filtersOpen = !!(panel && panel.classList.contains("is-open"));
      var qvOpen = !!(qv && qv.classList.contains("is-open") && !qv.hidden);
      document.documentElement.classList.toggle(
        "sa-plp-overlay-open",
        filtersOpen || qvOpen,
      );
    } catch (_e) {}
  }

  function closeFilters(root) {
    var backdrop = findPlpOverlay(root, "[data-selfabout-filter-backdrop]");
    var panel = findPlpOverlay(root, "[data-selfabout-filters]");
    if (backdrop) {
      backdrop.hidden = true;
      backdrop.setAttribute("aria-hidden", "true");
    }
    if (panel) {
      panel.classList.remove("is-open");
      panel.setAttribute("aria-hidden", "true");
      window.setTimeout(function () {
        panel.hidden = true;
        unportalPlpOverlay(panel);
        unportalPlpOverlay(backdrop);
        syncPlpOverlayChrome(root);
        syncToolbarPin(root);
      }, reducedMotion ? 0 : 220);
    } else {
      unportalPlpOverlay(backdrop);
    }
    lockScroll(false);
    syncPlpOverlayChrome(root);
    syncToolbarPin(root);
  }

  function openFilters(root) {
    ensureClientFacets(root);
    syncClientFacetInputs(root);
    syncPriceFacetInputs(root);
    normalizeActiveChips(root);
    renderClientActiveChips(root);
    refreshBundleAvailabilityCounts(root);
    var backdrop = findPlpOverlay(root, "[data-selfabout-filter-backdrop]");
    var panel = findPlpOverlay(root, "[data-selfabout-filters]");
    if (!panel) return;
    /* Hide scroll-pinned Sort/Filter bar while the sheet is open (mobile).
       CSS also covers this via html.sa-plp-overlay-open — unpin avoids a
       leftover fixed layer painting over / into the drawer. */
    unpinToolbar(root);
    portalPlpOverlay(root, backdrop);
    portalPlpOverlay(root, panel);
    panel.hidden = false;
    panel.setAttribute("aria-hidden", "false");
    if (backdrop) {
      backdrop.hidden = false;
      backdrop.setAttribute("aria-hidden", "false");
    }
    panel.classList.add("is-open");
    syncPlpOverlayChrome(root);
    lockScroll(true);
    syncPlpOverlayChrome(root);
    var focusTarget = panel.querySelector("input, button, select");
    if (focusTarget) focusTarget.focus();
  }

  function closeQuickView(root) {
    var backdrop = findPlpOverlay(root, "[data-selfabout-qv-backdrop]");
    var dialog = findPlpOverlay(root, "[data-selfabout-qv]");
    if (!dialog) return;
    dialog.classList.remove("is-open");
    syncPlpOverlayChrome(root);
    window.setTimeout(function () {
      dialog.hidden = true;
      if (backdrop) backdrop.hidden = true;
      unportalPlpOverlay(dialog);
      unportalPlpOverlay(backdrop);
      lockScroll(false);
      syncPlpOverlayChrome(root);
    }, reducedMotion ? 0 : 220);
  }

  function openQuickView(root) {
    var backdrop = findPlpOverlay(root, "[data-selfabout-qv-backdrop]");
    var dialog = findPlpOverlay(root, "[data-selfabout-qv]");
    if (!dialog) return;
    /* Portaled to body so iOS Safari sticky header (z-index 250) cannot
       paint above the modal trapped inside #sa-content-scroll. */
    portalPlpOverlay(root, backdrop);
    portalPlpOverlay(root, dialog);
    dialog.hidden = false;
    if (backdrop) backdrop.hidden = false;
    lockScroll(true);
    requestAnimationFrame(function () {
      dialog.classList.add("is-open");
      syncPlpOverlayChrome(root);
    });
    syncPlpOverlayChrome(root);
  }

  function navigateCollection(root, href, options) {
    options = options || {};
    setStatus(root, "");
    root.classList.add("is-loading");
    /* Do NOT strip sa-footer-ready here — is-loading CSS already hides footer.
       Clearing ready caused show→hide flap while gateFooter re-armed. */
    var bundlesTarget = hrefIsBundlesPlp(href);

    return fetch(href, {
      headers: { Accept: "text/html" },
      credentials: "same-origin",
    })
      .then(function (res) {
        if (!res.ok) throw new Error("fetch failed");
        return res.text();
      })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var nextRoot = doc.querySelector("[data-selfabout-collection]");
        if (!nextRoot) throw new Error("section missing");

        unpinToolbar(root);
        destroyOrphanToolbars(root);
        discardPortaledOverlays(root);
        root._saCatalog = null;
        root._saAvailCounts = null;
        root._saFilterRenderSig = "";
        root._saApplyingFilters = null;

        /* Update URL before isBundlesPlp() reads location (used by prune / polish) */
        if (!options.skipHistory) {
          window.history.pushState({ selfaboutPlp: true }, "", href);
        }

        var currentShell = root.querySelector(".selfabout-collection__shell");
        var nextShell = nextRoot.querySelector(".selfabout-collection__shell");
        if (currentShell && nextShell) {
          currentShell.innerHTML = nextShell.innerHTML;
        } else {
          root.innerHTML = nextRoot.innerHTML;
        }

        if (bundlesTarget || isBundlesPlp()) {
          root.setAttribute("data-sa-bundles-plp", "1");
          try {
            document.documentElement.setAttribute("data-sa-bundles-plp", "1");
            document.documentElement.setAttribute("data-sa-nav", "bundles");
          } catch (_h) { }
          pruneNonBundleCards(root);
          syncSoftNavActive("bundles");
        } else {
          root.removeAttribute("data-sa-bundles-plp");
          root.removeAttribute("data-sa-bundles-ready");
          try {
            document.documentElement.removeAttribute("data-sa-bundles-plp");
            document.documentElement.setAttribute("data-sa-nav", "shop");
          } catch (_h2) { }
          syncSoftNavActive("shop");
        }

        /* Sync collection chips from cache before paint — avoids hide/show flash */
        try {
          var cachedSiblings = readSiblingCollectionsCache();
          var siblingsNav = root.querySelector("[data-selfabout-siblings]");
          if (siblingsNav && cachedSiblings && !isBundlesPlp()) {
            siblingsNav.hidden = false;
            applySiblingCollections(siblingsNav, cachedSiblings);
          }
        } catch (_sib) { }

        var nextPerPage = nextRoot.getAttribute("data-per-page");
        if (nextPerPage) root.setAttribute("data-per-page", nextPerPage);

        afterRender(root);
        closeFilters(root);

        /* Keep dimmed/hidden until client filters finish — prevents all-products flash */
        var pending = root._saApplyingFilters;
        if (pending && typeof pending.then === "function") {
          pending.finally(function () {
            root.classList.remove("is-loading");
          });
        } else {
          root.classList.remove("is-loading");
        }

        if (!reducedMotion && options.scrollTop !== false) {
          root.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      })
      .catch(function () {
        root.classList.remove("is-loading");
        setStatus(root, "Could not update results. Try again.");
        if (!options.noFallback) window.location.href = href;
      });
  }

  function money(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents);
    }
    return (Number(cents) / 100).toFixed(2);
  }

  function findQvBody(root) {
    var dialog = findPlpOverlay(root, "[data-selfabout-qv]");
    if (dialog) return dialog.querySelector("[data-selfabout-qv-body]");
    return root ? root.querySelector("[data-selfabout-qv-body]") : null;
  }

  function renderQuickView(root, product) {
    var body = findQvBody(root);
    if (!body) return;
    var available = (product.variants || []).filter(function (v) {
      return v.available;
    });
    var selected = available[0] || (product.variants && product.variants[0]);
    var selectedId = selected && selected.id;
    var img =
      product.featured_image ||
      (product.images && product.images[0]) ||
      "";

    var variantsHtml = (product.variants || [])
      .map(function (v) {
        return (
          '<button type="button" class="selfabout-collection__qv-variant' +
          (v.id === selectedId ? " is-active" : "") +
          '" data-qv-variant="' +
          v.id +
          '"' +
          (v.available ? "" : " disabled") +
          ">" +
          (v.title || "Default") +
          "</button>"
        );
      })
      .join("");

    body.innerHTML =
      '<div class="selfabout-collection__qv-media">' +
      (img ? '<img src="' + img + '" alt="">' : "") +
      "</div>" +
      '<div class="selfabout-collection__qv-info">' +
      '<h3 class="selfabout-collection__qv-title"></h3>' +
      '<p class="selfabout-collection__qv-price" data-qv-price></p>' +
      (variantsHtml
        ? '<div class="selfabout-collection__qv-variants-wrap"><span class="selfabout-collection__qv-label">Select Option</span><div class="selfabout-collection__qv-variants">' +
        variantsHtml +
        "</div></div>"
        : "") +
      '<div class="selfabout-collection__qv-actions">' +
      '<div class="selfabout-collection__cart-slot selfabout-collection__cart-slot--qv" data-selfabout-cart-slot data-variant-id="' +
      (selectedId || "") +
      '">' +
      (selected && !selected.available
        ? '<button type="button" class="selfabout-collection__btn selfabout-collection__btn--ink" disabled>Sold out</button>'
        : '<button type="button" class="selfabout-collection__quick" data-selfabout-quick-add data-variant-id="' +
        (selectedId || "") +
        '" data-label="Add to cart"><span class="selfabout-collection__btn-label">Add to cart</span><span class="selfabout-collection__btn-spinner" aria-hidden="true"></span></button>') +
      "</div>" +
      '<a class="selfabout-collection__btn selfabout-collection__btn--ghost selfabout-collection__qv-details" href="' +
      (product.url || "#") +
      '">View full details</a>' +
      "</div>" +
      "</div>";

    body.querySelector(".selfabout-collection__qv-title").textContent =
      product.title || "";
    var priceNode = body.querySelector("[data-qv-price]");
    if (priceNode && selected) priceNode.textContent = money(selected.price);

    body._qvProduct = product;

    if (
      window.SelfAboutCart &&
      typeof window.SelfAboutCart.getCart === "function"
    ) {
      syncCartSlots(root, window.SelfAboutCart.getCart());
    } else {
      refreshCartUi(root);
    }
  }

  function syncSaveButtons(root) {
    var items = readJson(saveKey(root));
    var handles = {};
    items.forEach(function (item) {
      if (item && item.handle) handles[item.handle] = true;
    });
    root.querySelectorAll("[data-selfabout-save]").forEach(function (btn) {
      var on = Boolean(handles[btn.getAttribute("data-handle")]);
      btn.disabled = false;
      btn.classList.remove("is-loading", "is-busy");
      btn.setAttribute("aria-pressed", on ? "true" : "false");
      var label = btn.querySelector(".selfabout-collection__btn-label");
      if (label) label.textContent = on ? "Saved" : "Save";
      else btn.textContent = on ? "Saved" : "Save";
    });
  }

  function removeSavedHandle(root, handle) {
    if (!handle) return;
    var key = saveKey(root);
    var items = readJson(key).filter(function (item) {
      return item && item.handle && item.handle !== handle;
    });
    writeJson(key, items);
    syncSaveButtons(root);
    renderSavedTray(root);
  }

  function renderSavedTray(root) {
    var tray = root.querySelector("[data-selfabout-saved-tray]");
    var list = root.querySelector("[data-selfabout-saved-list]");
    if (!tray || !list) return;
    var items = readJson(saveKey(root));
    list.innerHTML = "";
    if (!items.length) {
      tray.hidden = true;
      return;
    }
    items.forEach(function (item) {
      if (!item || !item.handle) return;
      var row = document.createElement("div");
      row.className = "selfabout-collection__saved-item";
      row.setAttribute("data-saved-handle", item.handle);
      row.innerHTML =
        (item.image
          ? '<img src="' +
          String(item.image).replace(/"/g, "&quot;") +
          '" alt="" width="40" height="40">'
          : "<span aria-hidden=\"true\"></span>") +
        '<div class="selfabout-collection__saved-meta">' +
        '<a href="' +
        String(item.url || "#").replace(/"/g, "&quot;") +
        '"></a>' +
        "<div>" +
        String(item.price || "") +
        "</div></div>" +
        '<button type="button" class="selfabout-collection__saved-remove" data-selfabout-saved-remove data-handle="' +
        String(item.handle).replace(/"/g, "&quot;") +
        '" aria-label="Remove ' +
        String(item.title || item.handle).replace(/"/g, "&quot;") +
        ' from saved" title="Remove">' +
        '<svg viewBox="0 0 24 24" width="14" height="14" aria-hidden="true" focusable="false"><path fill="currentColor" d="M9 3h6l1 2h4v2H4V5h4l1-2zm1 6h2v9h-2V9zm4 0h2v9h-2V9zM7 9h2v9H7V9zm-1 12h12l1-12H5l1 12z"/></svg>' +
        "</button>";
      var link = row.querySelector("a");
      if (link) link.textContent = item.title || item.handle;
      list.appendChild(row);
    });
    tray.hidden = false;
  }

  var SIBLING_COL_SKIP = {
    all: 1,
    frontpage: 1,
    bundles: 1,
    kits: 1,
    shop: 1,
    "all-accessories": 1,
    catalog: 1,
    "everyday-carry": 1,
  };
  var SIBLING_CACHE_KEY = "sa_plp_sibling_collections_v1";

  function readSiblingCollectionsCache() {
    if (
      window.__saPlpSiblingCollections &&
      window.__saPlpSiblingCollections.length
    ) {
      return window.__saPlpSiblingCollections;
    }
    try {
      var raw = sessionStorage.getItem(SIBLING_CACHE_KEY);
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!Array.isArray(parsed) || !parsed.length) return null;
      window.__saPlpSiblingCollections = parsed;
      return parsed;
    } catch (_e) {
      return null;
    }
  }

  function writeSiblingCollectionsCache(items) {
    window.__saPlpSiblingCollections = items || [];
    try {
      sessionStorage.setItem(
        SIBLING_CACHE_KEY,
        JSON.stringify(window.__saPlpSiblingCollections),
      );
    } catch (_e) { }
  }

  function normalizeSiblingCollections(rows) {
    var items = [];
    for (var r = 0; r < rows.length; r++) {
      var col = rows[r];
      if (!col || !col.handle) continue;
      var handle = String(col.handle).toLowerCase();
      var count =
        typeof col.products_count === "number" ? col.products_count : 0;
      if (SIBLING_COL_SKIP[handle] || count < 1) continue;
      items.push({
        handle: handle,
        title: col.title || handle,
        url: col.url || "/collections/" + handle,
        published: Date.parse(col.published_at || 0) || 0,
        updated: Date.parse(col.updated_at || 0) || 0,
        id: Number(col.id) || 0,
      });
    }
    items.sort(function (a, b) {
      if (b.published !== a.published) return b.published - a.published;
      if (b.id !== a.id) return b.id - a.id;
      return String(a.title || "").localeCompare(String(b.title || ""));
    });
    return items;
  }

  function applySiblingCollections(nav, items) {
    if (!nav || !items) return;
    var shopLink = nav.querySelector("[data-handle='shop']");
    var allLink = nav.querySelector("[data-handle='collections']");
    var current = currentCollectionHandle();
    var existing = {};
    nav.querySelectorAll("[data-sa-sibling]").forEach(function (el) {
      var h = (el.getAttribute("data-handle") || "").toLowerCase();
      if (!h || h === "shop" || h === "collections") return;
      existing[h] = el;
    });

    var empty = nav.querySelector(".selfabout-collection__sibling-empty");
    if (empty && empty.parentNode) empty.parentNode.removeChild(empty);

    var insertBefore = allLink || null;
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      var node = existing[item.handle];
      if (node) {
        if ((node.textContent || "").trim() !== item.title) {
          node.textContent = item.title;
        }
        if (item.url) node.setAttribute("href", item.url);
        delete existing[item.handle];
      } else {
        node = document.createElement("a");
        node.className = "selfabout-collection__sibling";
        node.setAttribute("data-sa-sibling", "");
        node.setAttribute("data-handle", item.handle);
        node.href = item.url;
        node.textContent = item.title;
      }
      var on = current === item.handle;
      node.classList.toggle("is-active", on);
      if (on) node.setAttribute("aria-current", "page");
      else node.removeAttribute("aria-current");
      if (insertBefore) nav.insertBefore(node, insertBefore);
      else nav.appendChild(node);
    }

    Object.keys(existing).forEach(function (handle) {
      var dead = existing[handle];
      if (dead && dead.parentNode) dead.parentNode.removeChild(dead);
    });

    if (!items.length) {
      var placeholder = document.createElement("span");
      placeholder.className = "selfabout-collection__sibling-empty";
      placeholder.textContent = "Collections coming soon";
      if (allLink) nav.insertBefore(placeholder, allLink);
      else nav.appendChild(placeholder);
    }

    if (shopLink) {
      var shopOn = current === "all" || current === "shop";
      shopLink.classList.toggle("is-active", shopOn);
      if (shopOn) shopLink.setAttribute("aria-current", "page");
      else shopLink.removeAttribute("aria-current");
    }
    if (allLink) {
      allLink.classList.remove("is-active");
      allLink.removeAttribute("aria-current");
    }

    nav.setAttribute("data-sa-siblings-polished", "1");
  }

  function pruneEmptySiblingPills(nav) {
    if (!nav) return;
    nav.querySelectorAll("[data-sa-sibling]").forEach(function (el) {
      var h = (el.getAttribute("data-handle") || "").toLowerCase();
      if (h === "shop" || h === "collections") return;
      var text = (el.textContent || "").trim();
      var href = (el.getAttribute("href") || "").trim();
      if (!text || !href) {
        if (el.parentNode) el.parentNode.removeChild(el);
      }
    });
  }

  function polishSiblingBadges(root) {
    var nav = root.querySelector("[data-selfabout-siblings]");
    if (!nav) return;
    if (isBundlesPlp()) {
      nav.hidden = true;
      nav.setAttribute("hidden", "");
      return;
    }
    nav.hidden = false;
    nav.removeAttribute("hidden");
    pruneEmptySiblingPills(nav);

    var cached = readSiblingCollectionsCache();
    if (cached) {
      applySiblingCollections(nav, cached);
    }

    if (nav.getAttribute("data-sa-siblings-fetching") === "1") return;
    nav.setAttribute("data-sa-siblings-fetching", "1");

    fetch("/collections.json?limit=50", {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    })
      .then(function (res) {
        if (!res.ok) throw new Error("collections");
        return res.json();
      })
      .then(function (data) {
        var items = normalizeSiblingCollections(
          (data && data.collections) || [],
        );
        writeSiblingCollectionsCache(items);
        /* Re-query — shell may have swapped during fetch */
        var live =
          root.querySelector("[data-selfabout-siblings]") ||
          document.querySelector(
            "[data-selfabout-collection] [data-selfabout-siblings]",
          );
        if (live && !live.hidden) applySiblingCollections(live, items);
      })
      .catch(function () { })
      .finally(function () {
        nav.removeAttribute("data-sa-siblings-fetching");
        var live = root.querySelector("[data-selfabout-siblings]");
        if (live) live.removeAttribute("data-sa-siblings-fetching");
      });
  }

  function pruneRecentlyViewed(limit, options) {
    var silent = !!(options && options.silent);
    var max = Math.max(Number(limit) || 6, 6);
    var items = readJson(SELFABOUT_VIEWED_KEY).filter(function (item) {
      return item && item.handle;
    });
    function commit(valid) {
      var sliced = valid.slice(0, 12);
      var wrote = writeJson(SELFABOUT_VIEWED_KEY, sliced);
      var horizonIds = sliced
        .map(function (item) {
          return item && item.id ? String(item.id) : null;
        })
        .filter(Boolean)
        .slice(0, 8);
      try {
        var horizonRaw = JSON.stringify(horizonIds);
        if (window.localStorage.getItem(HORIZON_VIEWED_KEY) !== horizonRaw) {
          window.localStorage.setItem(HORIZON_VIEWED_KEY, horizonRaw);
          wrote = true;
        }
      } catch (_e) { }
      if (!silent && wrote) {
        try {
          document.dispatchEvent(
            new CustomEvent("selfabout:recently-viewed", {
              detail: { key: SELFABOUT_VIEWED_KEY, items: sliced },
            }),
          );
        } catch (_ev) { }
      }
      return sliced.slice(0, max);
    }
    if (!items.length) {
      var horizonOnly = getHorizonViewedIds();
      if (!horizonOnly.length) return Promise.resolve([]);
      return fetchHorizonViewedProducts(horizonOnly, max).then(function (mapped) {
        return commit(mapped || []);
      });
    }

    return Promise.all(
      items.slice(0, 12).map(function (item) {
        return fetch(rootUrl() + "products/" + encodeURIComponent(item.handle) + ".js", {
          credentials: "same-origin",
          headers: { Accept: "application/json" },
        })
          .then(function (res) {
            if (!res.ok) return null;
            return res.json().then(function (product) {
              if (!product || !product.handle) return null;
              var image =
                (product.featured_image &&
                  (product.featured_image.src || product.featured_image)) ||
                (product.images && product.images[0]) ||
                item.image ||
                null;
              if (image && typeof image === "object") image = image.src || null;
              var price =
                item.price ||
                (product.price != null
                  ? window.Shopify && Shopify.formatMoney
                    ? Shopify.formatMoney(product.price)
                    : "Rs." + (Number(product.price) / 100).toFixed(2)
                  : "");
              return {
                id: product.id != null ? String(product.id) : item.id || null,
                handle: product.handle,
                title: product.title || item.title || product.handle,
                url: item.url || "/products/" + product.handle,
                image: image,
                price: price,
                off: item.off || 0,
              };
            });
          })
          .catch(function () {
            return null;
          });
      }),
    ).then(function (results) {
      return commit(results.filter(Boolean));
    });
  }

  function revealPlpAffinityBlock(block) {
    if (!block) return;
    block.hidden = false;
    block.removeAttribute("hidden");
    block.style.removeProperty("display");
    var header = block.querySelector("header");
    if (header) {
      header.hidden = false;
      header.removeAttribute("hidden");
      header.style.removeProperty("display");
    }
    var rail = block.querySelector("[data-selfabout-plp-affinity-rail]");
    if (rail) {
      rail.removeAttribute("hidden");
      rail.hidden = false;
      rail.style.removeProperty("display");
    }
    var empty = block.querySelector("[data-selfabout-plp-affinity-empty]");
    if (empty) {
      empty.style.removeProperty("display");
    }
  }

  function ensureAffinityBlock(root) {
    if (!root) return null;
    if (root.getAttribute("data-sa-aff") === "0") return null;
    var block = root.querySelector("[data-selfabout-plp-affinity]");
    if (block) {
      block.setAttribute("data-limit", "6");
      revealPlpAffinityBlock(block);
      return block;
    }
    var shell = root.querySelector(".selfabout-collection__shell");
    if (!shell) return null;
    block = document.createElement("aside");
    block.className = "selfabout-collection__affinity sa-reveal is-in";
    block.setAttribute("data-selfabout-plp-affinity", "");
    block.setAttribute("data-storage-key", SELFABOUT_VIEWED_KEY);
    block.setAttribute("data-limit", "6");
    block.innerHTML =
      "<header><p class=\"selfabout-page__eyebrow\">Continue</p><h2>Recently viewed</h2></header>" +
      '<div class="selfabout-collection__affinity-rail" data-selfabout-plp-affinity-rail aria-live="polite"></div>' +
      '<div class="selfabout-collection__affinity-empty" data-selfabout-plp-affinity-empty hidden>' +
      '<p class="sa-affinity-empty-heading">Nothing here yet</p>' +
      '<p class="sa-affinity-empty-sub">Products you open will show up here for quick return.</p>' +
      "</div>";
    var saved = shell.querySelector("[data-selfabout-saved-tray]");
    if (saved) shell.insertBefore(block, saved);
    else shell.appendChild(block);
    revealPlpAffinityBlock(block);
    return block;
  }

  function initAffinity(root) {
    var block = ensureAffinityBlock(root);
    if (!block) return;
    var limit = Number(block.getAttribute("data-limit") || 6);
    var rail = block.querySelector("[data-selfabout-plp-affinity-rail]");
    var empty = block.querySelector("[data-selfabout-plp-affinity-empty]");
    if (!rail) return;

    revealPlpAffinityBlock(block);

    var cached = readJson(SELFABOUT_VIEWED_KEY)
      .filter(function (item) {
        return item && item.handle;
      })
      .slice(0, limit);
    var pendingSig = cached
      .map(function (item) {
        return item.handle;
      })
      .join(",");
    /* Avoid loading→paint blink when storage refresh has the same handles */
    if (
      block.getAttribute("data-sa-affinity-sig") === pendingSig &&
      rail.querySelector(".selfabout-collection__affinity-card")
    ) {
      return;
    }

    if (!rail.querySelector(".selfabout-collection__affinity-card")) {
      rail.innerHTML =
        '<p class="selfabout-collection__affinity-loading">Loading recent products...</p>';
    }
    if (empty) {
      empty.hidden = true;
      empty.setAttribute("hidden", "");
    }

    pruneRecentlyViewed(limit, { silent: true }).then(function (items) {
      var next = (items || []).slice(0, limit);
      var sig = next
        .map(function (item) {
          return item && item.handle;
        })
        .join(",");
      if (
        block.getAttribute("data-sa-affinity-sig") === sig &&
        rail.querySelector(".selfabout-collection__affinity-card")
      ) {
        return;
      }
      block.setAttribute("data-sa-affinity-sig", sig);
      renderAffinityItems(rail, empty, next);
      revealPlpAffinityBlock(block);
    });
  }

  function persistPageSize(size) {
    var allowed = { "12": true, "24": true, "36": true, "48": true };
    if (!allowed[String(size)]) return Promise.resolve();
    return fetch(rootUrl() + "cart/update.js", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify({
        attributes: { sa_plp_page_size: String(size) },
      }),
    }).catch(function () {
      /* cart update optional — still navigate */
    });
  }

  function ensurePageSizeSynced(root) {
    var params = new URLSearchParams(window.location.search);
    var urlSize = params.get("page_size");
    var rendered = root.getAttribute("data-per-page");
    if (!urlSize || !rendered || String(urlSize) === String(rendered)) return;
    if (root.getAttribute("data-sa-size-fix") === String(urlSize)) return;
    root.setAttribute("data-sa-size-fix", String(urlSize));
    persistPageSize(urlSize).then(function () {
      navigateCollection(root, window.location.pathname + window.location.search, {
        skipHistory: true,
        scrollTop: false,
      });
    });
  }

  function renderQuickAddButton(slot, variantId) {
    var isQv =
      slot &&
      slot.classList &&
      slot.classList.contains("selfabout-collection__cart-slot--qv");
    var label = isQv ? "Add to cart" : "Quick add";
    slot.innerHTML =
      '<button type="button" class="selfabout-collection__quick" data-selfabout-quick-add data-variant-id="' +
      variantId +
      '" data-label="' +
      label +
      '"><span class="selfabout-collection__btn-label">' +
      label +
      '</span><span class="selfabout-collection__btn-spinner" aria-hidden="true"></span></button>';
  }

  function renderQtyStepper(slot, variantId, quantity) {
    slot.innerHTML =
      '<div class="selfabout-collection__qty" data-selfabout-qty data-variant-id="' +
      variantId +
      '" role="group" aria-label="Quantity">' +
      '<button type="button" class="selfabout-collection__qty-btn" data-selfabout-qty-minus aria-label="Decrease quantity">' +
      '<span class="selfabout-collection__qty-glyph" aria-hidden="true">−</span>' +
      '<span class="selfabout-collection__qty-spinner" aria-hidden="true"></span>' +
      "</button>" +
      '<span class="selfabout-collection__qty-value" data-selfabout-qty-value>' +
      quantity +
      "</span>" +
      '<button type="button" class="selfabout-collection__qty-btn" data-selfabout-qty-plus aria-label="Increase quantity">' +
      '<span class="selfabout-collection__qty-glyph" aria-hidden="true">+</span>' +
      '<span class="selfabout-collection__qty-spinner" aria-hidden="true"></span>' +
      "</button>" +
      "</div>";
  }

  /* QV dialog is portaled to <body>, so slots there are outside root. */
  function collectCartSlots(root) {
    var slots = [];
    var seen = typeof WeakSet === "function" ? new WeakSet() : null;
    function pushAll(list) {
      if (!list) return;
      for (var i = 0; i < list.length; i++) {
        var slot = list[i];
        if (!slot) continue;
        if (seen) {
          if (seen.has(slot)) continue;
          seen.add(slot);
        } else if (slots.indexOf(slot) !== -1) {
          continue;
        }
        slots.push(slot);
      }
    }
    if (root) pushAll(root.querySelectorAll("[data-selfabout-cart-slot]"));
    var qv = findPlpOverlay(root, "[data-selfabout-qv]");
    if (qv) pushAll(qv.querySelectorAll("[data-selfabout-cart-slot]"));
    return slots;
  }

  function syncCartSlots(root, cart) {
    var qtyMap = cartQtyByVariant(cart || { items: [] });
    collectCartSlots(root).forEach(function (slot) {
      var variantId = String(slot.getAttribute("data-variant-id") || "");
      if (!variantId) return;
      var qty = qtyMap[variantId] || 0;
      var existingQty = slot.querySelector("[data-selfabout-qty]");
      var existingQuick = slot.querySelector("[data-selfabout-quick-add]");

      if (qty > 0) {
        if (
          existingQty &&
          String(existingQty.getAttribute("data-variant-id") || "") ===
          variantId
        ) {
          var valueEl = existingQty.querySelector("[data-selfabout-qty-value]");
          if (valueEl) {
            var nextText = String(qty);
            if (valueEl.textContent !== nextText) {
              valueEl.textContent = nextText;
              valueEl.classList.remove("is-flash");
              try {
                void valueEl.offsetWidth;
              } catch (_r) { }
              valueEl.classList.add("is-flash");
            }
          }
          existingQty.classList.remove("is-updating");
          slot.querySelectorAll(".selfabout-collection__qty-btn").forEach(
            function (btn) {
              btn.disabled = false;
              btn.classList.remove("is-loading");
              btn.removeAttribute("aria-busy");
            },
          );
          slot.removeAttribute("data-sa-qty-busy");
          return;
        }
        renderQtyStepper(slot, variantId, qty);
        slot.removeAttribute("data-sa-qty-busy");
        return;
      }

      if (!existingQuick) {
        renderQuickAddButton(slot, variantId);
      } else if (
        existingQuick.classList.contains("is-success") ||
        existingQuick.classList.contains("is-loading")
      ) {
        /* ATC just finished / busy — rebuild idle ATC when qty is 0 */
        renderQuickAddButton(slot, variantId);
      }
      slot.removeAttribute("data-sa-qty-busy");
    });
    bindCardActions(root);
  }

  function refreshCartUi(root) {
    return fetchCart().then(function (cart) {
      updateCartBadge(cart.item_count);
      if (root) syncCartSlots(root, cart);
      return cart;
    });
  }

  function handleQuickAdd(root, button) {
    var id = button.getAttribute("data-variant-id");
    var addLabel = button.getAttribute("data-label") || "Quick add";
    if (!id) return;
    if (button.disabled || button.classList.contains("is-loading")) return;
    setButtonLoading(button, true);
    addToCart(id, 1)
      .then(function () {
        setButtonSuccess(button, "Added", null);
        flyToCart(button);
        return refreshCartUi(root);
      })
      .then(function (cart) {
        openSelfAboutDrawer(cart);
      })
      .catch(function () {
        setButtonLoading(button, false);
        setStatus(root, "Could not add to cart. Try again.");
      });
  }

  function ensureQtyBtnChrome(btn) {
    if (!btn) return;
    if (btn.querySelector(".selfabout-collection__qty-spinner")) return;
    var glyph = btn.querySelector(".selfabout-collection__qty-glyph");
    if (!glyph) {
      var text = (btn.textContent || "").replace(/\s+/g, " ").trim() || "·";
      btn.textContent = "";
      glyph = document.createElement("span");
      glyph.className = "selfabout-collection__qty-glyph";
      glyph.setAttribute("aria-hidden", "true");
      glyph.textContent = text;
      btn.appendChild(glyph);
    }
    var spin = document.createElement("span");
    spin.className = "selfabout-collection__qty-spinner";
    spin.setAttribute("aria-hidden", "true");
    btn.appendChild(spin);
  }

  function handleQtyChange(root, slot, nextQty, activeBtn) {
    var variantId = slot.getAttribute("data-variant-id");
    if (!variantId) return;
    if (slot.getAttribute("data-sa-qty-busy") === "1") return;
    slot.setAttribute("data-sa-qty-busy", "1");

    var qty = Math.max(0, nextQty);
    var stepper = slot.querySelector("[data-selfabout-qty]");
    var valueEl = slot.querySelector("[data-selfabout-qty-value]");
    if (stepper) stepper.classList.add("is-updating");
    slot.querySelectorAll(".selfabout-collection__qty-btn").forEach(function (
      btn,
    ) {
      btn.disabled = true;
      btn.classList.remove("is-loading");
      btn.removeAttribute("aria-busy");
    });
    if (activeBtn) {
      ensureQtyBtnChrome(activeBtn);
      activeBtn.classList.add("is-loading");
      activeBtn.setAttribute("aria-busy", "true");
    }
    if (valueEl && qty > 0) {
      valueEl.textContent = String(qty);
      valueEl.classList.remove("is-flash");
      try {
        void valueEl.offsetWidth;
      } catch (_f) { }
      valueEl.classList.add("is-flash");
    }

    changeCartQuantity(variantId, qty)
      .then(function (cart) {
        updateCartBadge(cart.item_count);
        syncCartSlots(root, cart);
        if (window.SelfAboutCart && window.SelfAboutCart.notifyFromCart) {
          window.SelfAboutCart.notifyFromCart(cart);
        }
      })
      .catch(function () {
        setStatus(root, "Could not update cart. Try again.");
        return refreshCartUi(root);
      })
      .finally(function () {
        slot.removeAttribute("data-sa-qty-busy");
        if (stepper) stepper.classList.remove("is-updating");
        slot.querySelectorAll(".selfabout-collection__qty-btn").forEach(
          function (btn) {
            btn.disabled = false;
            btn.classList.remove("is-loading");
            btn.removeAttribute("aria-busy");
          },
        );
      });
  }

  function handleSave(root, button) {
    var handle = button.getAttribute("data-handle");
    if (!handle || button.disabled) return;
    setButtonLoading(button, true);
    window.setTimeout(function () {
      var key = saveKey(root);
      var items = readJson(key);
      var exists = items.some(function (item) {
        return item && item.handle === handle;
      });
      if (exists) {
        items = items.filter(function (item) {
          return item && item.handle !== handle;
        });
        writeJson(key, items);
        setButtonLoading(button, false);
        button.classList.add("is-success");
        var label = button.querySelector(".selfabout-collection__btn-label");
        if (label) label.textContent = "Removed";
        else button.textContent = "Removed";
        window.setTimeout(function () {
          button.classList.remove("is-success");
          syncSaveButtons(root);
          renderSavedTray(root);
        }, 500);
      } else {
        items.unshift({
          handle: handle,
          title: button.getAttribute("data-title") || handle,
          url: button.getAttribute("data-url") || "#",
          image: button.getAttribute("data-image") || null,
          price: button.getAttribute("data-price") || "",
        });
        items = items.slice(0, 24);
        writeJson(key, items);
        setButtonSuccess(button, "Saved", null);
        window.setTimeout(function () {
          syncSaveButtons(root);
          renderSavedTray(root);
        }, 500);
      }
    }, reducedMotion ? 0 : 160);
  }

  function handleQuickView(root, button) {
    var productUrl = button.getAttribute("data-product-url");
    if (!productUrl) return;
    var card = button.closest("[data-selfabout-card]");
    if (card) trackCardView(card);
    setButtonLoading(button, true);
    openQuickView(root);
    var body = findQvBody(root);
    if (!body) {
      setButtonLoading(button, false);
      return;
    }
    body.innerHTML =
      '<div class="selfabout-collection__qv-skeleton" aria-hidden="true"></div>';
    fetch(productUrl, { credentials: "same-origin" })
      .then(function (res) {
        if (!res.ok) throw new Error("product fetch failed");
        return res.json();
      })
      .then(function (product) {
        setButtonLoading(button, false);
        if (product && product.id) {
          pushHorizonViewedId(product.id);
          pushSelfaboutViewed({
            id: product.id,
            handle: product.handle,
            title: product.title,
            url: "/products/" + product.handle,
            image:
              (product.featured_image &&
                (product.featured_image.src || product.featured_image)) ||
              null,
            price:
              product.price != null
                ? window.Shopify && Shopify.formatMoney
                  ? Shopify.formatMoney(product.price)
                  : "Rs." + (Number(product.price) / 100).toFixed(2)
                : "",
          });
        }
        renderQuickView(root, product);
      })
      .catch(function () {
        setButtonLoading(button, false);
        body.innerHTML =
          "<p>Could not load product options. Open the product page instead.</p>";
      });
  }

  function bindCardActions(root) {
    if (!root) return;
    var scopes = [root];
    var qv = findPlpOverlay(root, "[data-selfabout-qv]");
    if (qv && scopes.indexOf(qv) === -1) scopes.push(qv);

    scopes.forEach(function (scope) {
      scope.querySelectorAll("[data-selfabout-quick-add]").forEach(function (btn) {
        if (btn.dataset.saBound === "1") return;
        btn.dataset.saBound = "1";
        btn.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
          handleQuickAdd(root, btn);
        });
      });
      scope.querySelectorAll("[data-selfabout-qty-plus]").forEach(function (btn) {
        if (btn.dataset.saBound === "1") return;
        btn.dataset.saBound = "1";
        btn.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
          var slot = btn.closest("[data-selfabout-cart-slot]");
          var value = slot && slot.querySelector("[data-selfabout-qty-value]");
          var current = value ? Number(value.textContent || 0) : 0;
          if (slot) handleQtyChange(root, slot, current + 1, btn);
        });
      });
      scope.querySelectorAll("[data-selfabout-qty-minus]").forEach(function (btn) {
        if (btn.dataset.saBound === "1") return;
        btn.dataset.saBound = "1";
        btn.addEventListener("click", function (event) {
          event.preventDefault();
          event.stopPropagation();
          var slot = btn.closest("[data-selfabout-cart-slot]");
          var value = slot && slot.querySelector("[data-selfabout-qty-value]");
          var current = value ? Number(value.textContent || 0) : 0;
          if (slot) handleQtyChange(root, slot, Math.max(0, current - 1), btn);
        });
      });
    });

    root.querySelectorAll("[data-selfabout-save]").forEach(function (btn) {
      if (btn.dataset.saBound === "1") return;
      btn.dataset.saBound = "1";
      btn.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        handleSave(root, btn);
      });
    });
    root.querySelectorAll("[data-selfabout-quick-view]").forEach(function (btn) {
      if (btn.dataset.saBound === "1") return;
      btn.dataset.saBound = "1";
      btn.addEventListener("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        handleQuickView(root, btn);
      });
    });
  }

  function fixBrokenCardImages(root) {
    if (!root) return;
    root.querySelectorAll(".selfabout-collection__media").forEach(function (media) {
      var imgs = media.querySelectorAll("img.selfabout-collection__img");
      if (!imgs.length) {
        media.classList.add("is-missing-image");
        if (!media.querySelector(".selfabout-collection__placeholder")) {
          var empty = document.createElement("span");
          empty.className = "selfabout-collection__placeholder";
          empty.setAttribute("aria-hidden", "true");
          media.appendChild(empty);
        }
        return;
      }
      imgs.forEach(function (img) {
        function replaceWithPlaceholder() {
          img.classList.add("is-broken");
          media.classList.add("is-missing-image");
          if (!media.querySelector(".selfabout-collection__placeholder")) {
            var ph = document.createElement("span");
            ph.className = "selfabout-collection__placeholder";
            ph.setAttribute("aria-hidden", "true");
            media.appendChild(ph);
          }
          try {
            img.remove();
          } catch (_e) {
            img.style.display = "none";
          }
        }
        img.addEventListener("error", replaceWithPlaceholder, { once: true });
        if (img.complete && img.naturalWidth === 0) replaceWithPlaceholder();
      });
    });
  }

  function syncPriceFacetInputs(root) {
    var form = findFiltersForm(root);
    if (!form) return;
    var params = new URLSearchParams(window.location.search || "");
    form.querySelectorAll('input[type="number"]').forEach(function (input) {
      var name = input.getAttribute("name") || "";
      if (!/price/i.test(name)) return;
      if (params.has(name)) {
        /* URL uses major currency units (30); Liquid often rehydrates cents (3000). */
        input.value = params.get(name);
        return;
      }
      var raw = String(input.value || "").trim();
      if (!raw) return;
      var n = Number(raw);
      if (!Number.isFinite(n) || n === 0) return;
      /* Idle defaults from Shopify are cents — show major units for editing */
      if (Number.isInteger(n) && Math.abs(n) >= 100 && !/\./.test(raw)) {
        input.value = String(n / 100);
      }
    });
  }

  function polishHeroChips(root) {
    var chip = root.querySelector(
      '[data-sa-hero-chip="bundles"], [data-sa-hero-chip="shop-all"]',
    );
    if (!chip) return;
    if (isBundlesPlp()) {
      chip.textContent = "Shop all";
      chip.setAttribute("href", "/collections/all");
      chip.setAttribute("data-sa-hero-chip", "shop-all");
      chip.setAttribute("title", "Shop all products");
    } else {
      chip.textContent = "Bundles";
      chip.setAttribute(
        "href",
        "/collections/all?sa_type=bundle&sort_by=created-descending",
      );
      chip.setAttribute("data-sa-hero-chip", "bundles");
      chip.setAttribute("title", "Shop bundles");
    }
  }

  function polishBundlesHero(root) {
    if (!isBundlesPlp()) {
      try {
        document.documentElement.removeAttribute("data-sa-bundles-plp");
        if (root) root.removeAttribute("data-sa-bundles-plp");
        if (/\/collections\/all(\/|$)/i.test(location.pathname || "")) {
          var shopTitle = "Products – " + shopNameSuffix();
          if (/^bundles\s*[–—-]/i.test(document.title || "")) {
            document.title = shopTitle;
          }
          document.documentElement.setAttribute("data-sa-nav", "shop");
          syncSoftNavActive("shop");
        }
      } catch (_e) { }
      polishHeroChips(root);
      ensureAffinityBlock(root);
      return;
    }
    try {
      document.documentElement.setAttribute("data-sa-nav", "bundles");
      document.documentElement.setAttribute("data-sa-bundles-plp", "1");
      if (root) root.setAttribute("data-sa-bundles-plp", "1");
      syncSoftNavActive("bundles");
    } catch (_m) { }
    var eye = root.querySelector(".selfabout-collection__hero .selfabout-page__eyebrow");
    var title = root.querySelector(".selfabout-collection__title");
    var desc = root.querySelector(".selfabout-collection__desc");
    var crumbs = root.querySelector(".selfabout-collection__crumbs");
    if (eye) eye.textContent = "Bundles";
    if (title) title.textContent = "Bundles";
    if (desc && !desc.querySelector("p, div, span")) {
      desc.textContent =
        "You need for your daily routine, perfectly color-matched. Upgrade your style and tech essentials in one complete bundle.";
    }
    if (crumbs) {
      crumbs.innerHTML =
        '<a href="' +
        rootUrl() +
        '">Home</a><span aria-hidden="true">/</span><span aria-current="page">Bundles</span>';
    }
    try {
      document.title = "Bundles – " + shopNameSuffix();
    } catch (_t) { }

    var siblings = root.querySelector("[data-selfabout-siblings]");
    if (siblings) {
      siblings.hidden = true;
      siblings.setAttribute("hidden", "");
    }
    var merch = root.querySelector(".selfabout-collection__merch");
    if (merch) merch.hidden = true;

    root.querySelectorAll(
      ".selfabout-collection__badge--kit, [data-selfabout-kit-badge]",
    ).forEach(function (badge) {
      if (badge.parentNode) badge.parentNode.removeChild(badge);
    });
    polishHeroChips(root);
    /* Reveal hero/count after polish — CSS hides until data-sa-bundles-ready */
    try {
      root.setAttribute("data-sa-bundles-ready", "1");
    } catch (_r) { }
    /* Bundles must keep Shop-parity recently viewed */
    ensureAffinityBlock(root);
  }

  function polishKitBadges(root) {
    if (isBundlesPlp()) return;
    root.querySelectorAll("a.selfabout-collection__badge--kit").forEach(
      function (badge) {
        badge.setAttribute("title", "View bundles");
      },
    );
  }

  function ensureDefaultSort(root) {
    if (!root || root.getAttribute("data-sa-default-sort") === "1") return false;
    var params = new URLSearchParams(window.location.search || "");
    if (params.get("sort_by")) {
      root.setAttribute("data-sa-default-sort", "1");
      return false;
    }
    var select = queryToolbar(root, "[data-selfabout-sort]");
    if (
      !select ||
      !select.querySelector('option[value="created-descending"]')
    ) {
      root.setAttribute("data-sa-default-sort", "1");
      return false;
    }
    root.setAttribute("data-sa-default-sort", "1");
    params.set("sort_by", "created-descending");
    select.value = "created-descending";
    var qs = params.toString();
    var href = window.location.pathname + (qs ? "?" + qs : "");
    try {
      window.history.replaceState({ selfaboutPlp: true }, "", href);
    } catch (_e) { }
    navigateCollection(root, href, { skipHistory: true, scrollTop: false });
    return true;
  }

  function afterRender(root) {
    if (root && root.hasAttribute("data-sa-search-plp")) {
      syncSaveButtons(root);
      bindCardActions(root);
      fixBrokenCardImages(root);
      refreshCartUi(root).catch(function () { });
      try {
        document.dispatchEvent(
          new CustomEvent("selfabout:dom-updated", { detail: { root: root } }),
        );
      } catch (_e) { }
      return;
    }
    sanitizeClientFacetParams();
    if (ensureDefaultSort(root)) return;
    restoreDensity(root);
    polishSortOptions(root);
    syncControlsFromUrl(root);
    syncSaveButtons(root);
    bindCardActions(root);
    polishSiblingBadges(root);
    polishBundlesHero(root);
    polishKitBadges(root);
    initAffinity(root);
    syncStickyOffset(root);
    destroyOrphanToolbars(root);
    bindToolbarPin();
    var toolbar = findToolbar(
      root,
      root.querySelector("[data-selfabout-toolbar-slot]"),
    );
    if (toolbar) toolbar.classList.add("is-in");
    syncToolbarPin(root);
    fixBrokenCardImages(root);
    if (readJson(saveKey(root)).length) renderSavedTray(root);
    ensurePageSizeSynced(root);
    ensureClientFacets(root);
    syncClientFacetInputs(root);
    syncPriceFacetInputs(root);
    preserveClientParamsOnLinks(root);
    normalizeActiveChips(root);
    renderClientActiveChips(root);
    applyClientFilters(root);
    refreshBundleAvailabilityCounts(root);
    refreshCartUi(root).catch(function () { });
    try {
      document.dispatchEvent(
        new CustomEvent("selfabout:dom-updated", { detail: { root: root } }),
      );
    } catch (_e) { }
  }

  function flashSuccess(button, label) {
    setButtonSuccess(button, "Added", label);
  }

  function onClick(event) {
    var target = event.target;
    if (target && target.nodeType === 3) target = target.parentElement;
    if (!target || !target.closest) return;
    var root = getRoot(target);
    if (!root) return;

    var densityBtn = target.closest("[data-density]");
    if (densityBtn && isToolbarControl(root, densityBtn)) {
      applyDensity(root, densityBtn.getAttribute("data-density") || "4");
      return;
    }

    var heroChip = target.closest("[data-sa-hero-chip]");
    if (heroChip && root.contains(heroChip)) {
      event.preventDefault();
      var chipHref = heroChip.getAttribute("href");
      if (chipHref) navigateCollection(root, chipHref);
      return;
    }

    var sibling = target.closest("[data-sa-sibling]");
    if (sibling && root.contains(sibling)) {
      trackSiblingClick(sibling);
      var handle = (sibling.getAttribute("data-handle") || "").toLowerCase();
      /* Keep chip row stable — AJAX swap + cached sibling sync (no full reload flash) */
      if (handle && handle !== "collections") {
        event.preventDefault();
        var href = sibling.href || sibling.getAttribute("href");
        if (href) navigateCollection(root, href);
        return;
      }
    }

    var pageSizeBtn = target.closest("[data-page-size]");
    if (pageSizeBtn && isToolbarControl(root, pageSizeBtn)) {
      var nextSize = pageSizeBtn.getAttribute("data-page-size") || "24";
      applyPageSize(root, nextSize);
      var form = findFiltersForm(root);
      var href = buildFilterUrl(root, form);
      persistPageSize(nextSize).then(function () {
        navigateCollection(root, href);
      });
      return;
    }

    if (target.closest("[data-selfabout-filter-open]")) {
      openFilters(root);
      return;
    }

    if (
      target.closest("[data-selfabout-filter-close]") ||
      target.closest("[data-selfabout-filter-backdrop]")
    ) {
      closeFilters(root);
      return;
    }

    var filterLink = target.closest("[data-selfabout-filter-link]");
    if (filterLink) {
      event.preventDefault();
      var isClear =
        filterLink.classList.contains("selfabout-collection__clear") ||
        /clear all/i.test(filterLink.textContent || "");
      var nextHref;
      if (isPaginationFilterLink(filterLink)) {
        nextHref = mergePaginationHref(filterLink.href);
      } else if (isClear || isClientChipRemoveLink(filterLink)) {
        /* Chip/clear hrefs already encode the intended params — don't re-merge */
        nextHref = filterLink.getAttribute("href") || filterLink.href;
      } else {
        nextHref = mergeClientParamsIntoHref(filterLink.href);
      }
      if (isClear || filterLink.closest("[data-selfabout-filters]")) {
        setFilterActionsLoading(root, true, isClear ? "clear" : "apply");
      }
      navigateCollection(root, nextHref).finally(function () {
        setFilterActionsLoading(root, false);
      });
      return;
    }

    if (target.closest("[data-kit-pick]")) {
      return;
    }

    var productLink = target.closest(
      "[data-selfabout-card] a[href*='/products/']",
    );
    if (productLink && !target.closest("[data-selfabout-card-actions]")) {
      trackCardView(productLink.closest("[data-selfabout-card]"));
    }

    /* Card actions are bound directly in bindCardActions — skip here if already bound.
       Search PLP card chrome uses capture delegation (survives grid re-renders).
       Quick-view dialog/backdrop still live inside [data-sa-search-plp], so do not
       early-return those — otherwise close/variants never run and the page freezes. */
    var onSearchPlp = Boolean(target.closest("[data-sa-search-plp]"));
    var onSearchQv = Boolean(
      target.closest(
        "[data-selfabout-qv], [data-selfabout-qv-backdrop], [data-selfabout-qv-close], [data-qv-variant], [data-qv-add]",
      ),
    );
    if (onSearchPlp && !onSearchQv) return;

    var quickAdd = target.closest("[data-selfabout-quick-add]");
    if (quickAdd && quickAdd.dataset.saBound !== "1") {
      event.preventDefault();
      handleQuickAdd(root, quickAdd);
      return;
    }

    var quickView = target.closest("[data-selfabout-quick-view]");
    if (quickView && quickView.dataset.saBound !== "1") {
      event.preventDefault();
      handleQuickView(root, quickView);
      return;
    }

    var saveBtn = target.closest("[data-selfabout-save]");
    if (saveBtn && saveBtn.dataset.saBound !== "1") {
      event.preventDefault();
      handleSave(root, saveBtn);
      return;
    }

    if (
      target.closest("[data-selfabout-qv-close]") ||
      target.closest("[data-selfabout-qv-backdrop]")
    ) {
      closeQuickView(root);
      return;
    }

    var qvVariant = target.closest("[data-qv-variant]");
    if (qvVariant) {
      var qvBody = findQvBody(root);
      var product = qvBody && qvBody._qvProduct;
      if (!product) return;
      qvBody.querySelectorAll("[data-qv-variant]").forEach(function (chip) {
        chip.classList.remove("is-active");
      });
      qvVariant.classList.add("is-active");
      var vid = Number(qvVariant.getAttribute("data-qv-variant"));
      var variant = (product.variants || []).find(function (v) {
        return v.id === vid;
      });
      var slot = qvBody.querySelector("[data-selfabout-cart-slot]");
      if (slot && variant) {
        slot.setAttribute("data-variant-id", String(vid));
        if (!variant.available) {
          slot.innerHTML =
            '<button type="button" class="selfabout-collection__btn selfabout-collection__btn--ink" disabled>Sold out</button>';
        } else {
          slot.innerHTML =
            '<button type="button" class="selfabout-collection__quick" data-selfabout-quick-add data-variant-id="' +
            String(vid) +
            '" data-label="Add to cart"><span class="selfabout-collection__btn-label">Add to cart</span><span class="selfabout-collection__btn-spinner" aria-hidden="true"></span></button>';
        }
      }
      var priceNode = qvBody.querySelector("[data-qv-price]");
      if (priceNode && variant) priceNode.textContent = money(variant.price);

      if (
        window.SelfAboutCart &&
        typeof window.SelfAboutCart.getCart === "function"
      ) {
        syncCartSlots(root, window.SelfAboutCart.getCart());
      } else {
        refreshCartUi(root);
      }
      return;
    }

    var qvAdd = target.closest("[data-qv-add]");
    if (qvAdd) {
      event.preventDefault();
      var variantId = qvAdd.getAttribute("data-variant-id");
      if (!variantId) return;
      qvAdd.disabled = true;
      addToCart(variantId)
        .then(function () {
          flashSuccess(qvAdd, "Add to cart");
          return refreshCartUi(root);
        })
        .then(function (cart) {
          qvAdd.disabled = false;
          openSelfAboutDrawer(cart);
        })
        .catch(function () {
          qvAdd.disabled = false;
          setStatus(root, "Could not add to cart. Try again.");
        });
      return;
    }

    if (target.closest("[data-selfabout-saved-close]")) {
      var tray = root.querySelector("[data-selfabout-saved-tray]");
      if (tray) tray.hidden = true;
      return;
    }

    var removeSaved = target.closest("[data-selfabout-saved-remove]");
    if (removeSaved && root.contains(removeSaved)) {
      event.preventDefault();
      removeSavedHandle(root, removeSaved.getAttribute("data-handle") || "");
      return;
    }

    if (target.closest("[data-selfabout-open-search]")) {
      var searchBtn =
        document.querySelector("[data-selfabout-search-open]") ||
        document.querySelector(".header__icon--search");
      if (searchBtn) searchBtn.click();
      else window.location.href = "/search";
    }
  }

  function onSubmit(event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches("[data-selfabout-filters-form]")) {
      return;
    }
    event.preventDefault();
    var root = getRoot(form);
    if (!root) return;
    setFilterActionsLoading(root, true, "apply");
    navigateCollection(root, buildFilterUrl(root, form)).finally(function () {
      setFilterActionsLoading(root, false);
    });
  }

  function onChange(event) {
    var select = event.target;
    if (
      !select ||
      !select.matches ||
      !(
        select.matches("[data-selfabout-sort]") ||
        select.matches("[data-selfabout-page-size]")
      )
    ) {
      return;
    }
    var root = getRoot(select);
    if (!root) return;
    var form = findFiltersForm(root);
    var overrides = {};
    if (select.matches("[data-selfabout-sort]")) {
      overrides.sortBy = select.value;
    }
    if (select.matches("[data-selfabout-page-size]")) {
      overrides.pageSize = select.value;
    }
    var href = buildFilterUrl(root, form, overrides);
    if (select.matches("[data-selfabout-page-size]")) {
      /* Chrome device-mode keeps native <select> open across soft-nav — kill popup UI */
      var size = select.value;
      try {
        select.blur();
      } catch (_blur) {}
      if (select.closest("[data-selfabout-filters]")) {
        try {
          closeFilters(root);
        } catch (_close) {}
      }
      try {
        /* Cloning detaches Chrome's stuck native picker on desktop responsive mode */
        if (select.parentNode) {
          var clone = select.cloneNode(true);
          clone.value = size;
          select.parentNode.replaceChild(clone, select);
          select = clone;
        }
      } catch (_clone) {}
      window.setTimeout(function () {
        try {
          if (select && document.activeElement === select) select.blur();
        } catch (_blur2) {}
        applyPageSize(root, size);
        persistPageSize(size).then(function () {
          navigateCollection(root, href);
        });
      }, 0);
      return;
    }
    navigateCollection(root, href);
  }

  function onKeydown(event) {
    if (event.key !== "Escape") return;
    document.querySelectorAll("[data-selfabout-collection]").forEach(function (root) {
      var filters = findPlpOverlay(root, "[data-selfabout-filters]");
      var qv = findPlpOverlay(root, "[data-selfabout-qv]");
      if (qv && !qv.hidden) closeQuickView(root);
      else if (filters && !filters.hidden) closeFilters(root);
    });
  }

  function refreshSearchPlp(root) {
    var plp =
      root && root.nodeType === 1 && root.hasAttribute("data-sa-search-plp")
        ? root
        : document.querySelector("[data-sa-search-plp]");
    if (!plp) return;
    syncSaveButtons(plp);
    bindCardActions(plp);
    fixBrokenCardImages(plp);
    refreshCartUi(plp).catch(function () { });
  }

  function onSearchPlpClick(event) {
    var target = event.target;
    if (target && target.nodeType === 3) target = target.parentElement;
    if (!target || !target.closest) return;

    var plp = target.closest("[data-sa-search-plp]");
    if (!plp) {
      /* QV is portaled to <body> — resolve back to the search PLP root */
      var portaledQv = target.closest(
        "[data-selfabout-qv], [data-selfabout-qv-backdrop], [data-selfabout-qv-close]",
      );
      if (portaledQv) {
        var viaRoot = getRoot(target);
        if (viaRoot && viaRoot.hasAttribute("data-sa-search-plp")) plp = viaRoot;
      }
    }
    if (!plp) return;

    function inPlpUi(el) {
      if (!el) return false;
      if (plp.contains(el)) return true;
      var qv = findPlpOverlay(plp, "[data-selfabout-qv]");
      return Boolean(qv && qv.contains(el));
    }

    /* Close QV in capture so backdrop/X always win even if bubble is blocked. */
    if (
      target.closest("[data-selfabout-qv-close]") ||
      target.closest("[data-selfabout-qv-backdrop]")
    ) {
      event.preventDefault();
      event.stopPropagation();
      closeQuickView(plp);
      return;
    }

    var quickAdd = target.closest("[data-selfabout-quick-add]");
    if (quickAdd && inPlpUi(quickAdd)) {
      if (quickAdd.disabled || quickAdd.classList.contains("is-loading")) return;
      event.preventDefault();
      event.stopPropagation();
      handleQuickAdd(plp, quickAdd);
      return;
    }

    var saveBtn = target.closest("[data-selfabout-save]");
    if (saveBtn && plp.contains(saveBtn)) {
      if (saveBtn.disabled || saveBtn.classList.contains("is-loading")) return;
      event.preventDefault();
      event.stopPropagation();
      handleSave(plp, saveBtn);
      return;
    }

    var qtyPlus = target.closest("[data-selfabout-qty-plus]");
    if (qtyPlus && inPlpUi(qtyPlus)) {
      if (qtyPlus.disabled || qtyPlus.classList.contains("is-loading")) return;
      event.preventDefault();
      event.stopPropagation();
      var plusSlot = qtyPlus.closest("[data-selfabout-cart-slot]");
      var plusValue =
        plusSlot && plusSlot.querySelector("[data-selfabout-qty-value]");
      var plusCurrent = plusValue ? Number(plusValue.textContent || 0) : 0;
      if (plusSlot) handleQtyChange(plp, plusSlot, plusCurrent + 1, qtyPlus);
      return;
    }

    var qtyMinus = target.closest("[data-selfabout-qty-minus]");
    if (qtyMinus && inPlpUi(qtyMinus)) {
      if (qtyMinus.disabled || qtyMinus.classList.contains("is-loading")) return;
      event.preventDefault();
      event.stopPropagation();
      var minusSlot = qtyMinus.closest("[data-selfabout-cart-slot]");
      var minusValue =
        minusSlot && minusSlot.querySelector("[data-selfabout-qty-value]");
      var minusCurrent = minusValue ? Number(minusValue.textContent || 0) : 0;
      if (minusSlot) {
        handleQtyChange(plp, minusSlot, Math.max(0, minusCurrent - 1), qtyMinus);
      }
    }
  }

  function boot() {
    if (booted) return;
    booted = true;

    /* Activate scroll shell on collection pages.
       nav-boot exposes window.__saHardenScrollShell — selfabout-product.js calls
       it on PDP pages, but collection pages were missing this call, causing body
       scroll (native scrollbar, sticky filter broken on desktop). */
    try {
      if (typeof window.__saHardenScrollShell === "function") {
        window.__saHardenScrollShell({ forceReset: true });
      }
    } catch (_sh) {}

    /* Belt-and-suspenders: add sa-content-scroll to <html> directly.
       nav-boot's ensureContentScroll() calls classList.add() inside withDomLock();
       if that lock is held at boot time the class is never applied, leaving the
       native scrollbar and disabling the CSS overflow lock.
       We verify #sa-content-scroll actually wraps #MainContent before adding the
       class so we don't break pages where the shell isn't ready yet. */
    try {
      var _saShell = document.getElementById("sa-content-scroll");
      var _saMain = document.getElementById("MainContent") || document.querySelector("main");
      if (
        _saShell && _saMain && _saShell.contains(_saMain) &&
        !document.documentElement.classList.contains("sa-content-scroll")
      ) {
        document.documentElement.classList.add("sa-content-scroll");
      }
    } catch (_cls) {}

    /* Retry on window.load for edge cases where nav-boot runs after DOMContentLoaded */
    window.addEventListener("load", function () {
      try {
        if (
          typeof window.__saHardenScrollShell === "function" &&
          !document.documentElement.classList.contains("sa-content-scroll")
        ) {
          window.__saHardenScrollShell({ forceReset: true });
        }
        /* Second direct fallback after full page load */
        var _sh2Shell = document.getElementById("sa-content-scroll");
        var _sh2Main = document.getElementById("MainContent") || document.querySelector("main");
        if (
          _sh2Shell && _sh2Main && _sh2Shell.contains(_sh2Main) &&
          !document.documentElement.classList.contains("sa-content-scroll")
        ) {
          document.documentElement.classList.add("sa-content-scroll");
        }
      } catch (_sh2) {}
    }, { once: true });

    try {
      discardPortaledOverlays(null);
    } catch (_bootClean) {}
    document.addEventListener("click", onSearchPlpClick, true);
    document.addEventListener("click", onClick);
    document.addEventListener("submit", onSubmit);
    document.addEventListener("change", onChange);
    document.addEventListener("keydown", onKeydown);
    window.addEventListener("resize", function () {
      syncAllToolbarPins();
    });
    window.addEventListener("pageshow", refreshPlpAffinity);
    document.addEventListener("visibilitychange", function () {
      if (document.visibilityState === "visible") refreshPlpAffinity();
    });
    document.addEventListener("selfabout:recently-viewed", refreshPlpAffinity);
    /* Cross-tab / PDP → PLP real-time sync: fire refreshPlpAffinity whenever
       any recently-viewed localStorage key changes from another page. */
    window.addEventListener("storage", function (event) {
      if (
        event.key === "selfabout_recently_viewed" ||
        event.key === "selfabout_plp_viewed"
      ) {
        refreshPlpAffinity();
      }
    });
    document.addEventListener("selfabout:ratings-ready", function (event) {
      try {
        window.__saCardRatingsMap =
          (event.detail && event.detail.ratings) || window.__saCardRatingsMap;
      } catch (_e) { }
      document.querySelectorAll("[data-selfabout-collection]").forEach(function (root) {
        if (root._saApplyingFilters) return;
        var params = new URLSearchParams(window.location.search || "");
        if (!params.get("sa_rating") && !hasClientFilters(params)) return;
        root._saFilterRenderSig = "";
        applyClientFilters(root);
      });
    });

    document.querySelectorAll("[data-selfabout-collection]").forEach(afterRender);

    // Keep PLP Quick add / qty steppers in sync with cart drawer (qty +/−, remove).
    document.addEventListener("selfabout:cart", function (event) {
      var cart = event.detail && event.detail.cart;
      var roots = document.querySelectorAll("[data-selfabout-collection]");
      if (!roots.length) return;
      if (cart) {
        if (typeof cart.item_count === "number") updateCartBadge(cart.item_count);
        roots.forEach(function (root) {
          syncCartSlots(root, cart);
        });
        return;
      }
      roots.forEach(function (root) {
        refreshCartUi(root).catch(function () { });
      });
    });

    window.addEventListener("popstate", function () {
      var root = document.querySelector(
        "[data-selfabout-collection]:not([data-sa-search-plp])",
      );
      if (!root) return;
      navigateCollection(root, window.location.href, {
        skipHistory: true,
        noFallback: true,
        scrollTop: false,
      });
    });

    try {
      window.SelfAboutCollection = window.SelfAboutCollection || {};
      window.SelfAboutCollection.refreshSearchPlp = refreshSearchPlp;
      window.SelfAboutCollection.afterRender = afterRender;
    } catch (_api) { }

    /* Cover hover next-image — class fallback when @media (hover) is unreliable */
    document.addEventListener(
      "pointerover",
      function (event) {
        var t = event.target;
        if (!t || !t.closest || event.pointerType === "touch") return;
        var wrap = t.closest(".selfabout-collection__media-wrap");
        if (!wrap) return;
        var card = wrap.closest("[data-selfabout-card]");
        if (!card || card.classList.contains("is-kit-manual")) return;
        if (!card.querySelector(".selfabout-collection__img--alt")) return;
        card.classList.add("is-cover-hover");
      },
      true,
    );
    document.addEventListener(
      "pointerout",
      function (event) {
        var t = event.target;
        if (!t || !t.closest) return;
        var wrap = t.closest(".selfabout-collection__media-wrap");
        if (!wrap) return;
        var to = event.relatedTarget;
        if (to && wrap.contains(to)) return;
        var card = wrap.closest("[data-selfabout-card]");
        if (card) card.classList.remove("is-cover-hover");
      },
      true,
    );
  }

  /* Defer scripts run after HTML parse — strip non-bundles before first interactive paint */
  try {
    if (isBundlesPlp()) {
      document.documentElement.setAttribute("data-sa-nav", "bundles");
      document.documentElement.setAttribute("data-sa-bundles-plp", "1");
      document.querySelectorAll("[data-selfabout-collection]").forEach(function (root) {
        root.setAttribute("data-sa-bundles-plp", "1");
        pruneNonBundleCards(root);
      });
    }
  } catch (_early) { }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
